import React from "react";
var AddBox = function AddBox(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 0h14c1.1 0 2 .9 2 2v14c0 1.1-.9 2-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2zm8 10h3c.55 0 1-.45 1-1s-.45-1-1-1h-3V5c0-.55-.45-1-1-1s-1 .45-1 1v3H5c-.55 0-1 .45-1 1s.45 1 1 1h3v3c0 .55.45 1 1 1s1-.45 1-1v-3z",
    fill: "#CED3D6"
  }));
};
AddBox.displayName = "AddBox";
AddBox.defaultProps = {
  width: "18",
  height: "18",
  viewBox: "0 0 18 18",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var Business = function Business(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 5v2h8c1.1 0 2 .9 2 2v10c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V5c0-1.1.9-2 2-2h6c1.1 0 2 .9 2 2zM4 19h2v-2H4v2zm2-4H4v-2h2v2zm-2-4h2V9H4v2zm2-4H4V5h2v2zm2 12h2v-2H8v2zm2-4H8v-2h2v2zm-2-4h2V9H8v2zm2-4H8V5h2v2zm2 12h7c.55 0 1-.45 1-1v-8c0-.55-.45-1-1-1h-7v2h2v2h-2v2h2v2h-2v2zm6-8h-2v2h2v-2zm-2 4h2v2h-2v-2z",
    fill: "#9da3a8"
  }));
};
Business.displayName = "Business";
Business.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var CalendarTodayBlack = function CalendarTodayBlack(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)",
    fill: "#42A8D5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 3h-1V1h-2v2H7V1H5v2H4c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 18H4V8h16v13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.796 16.02c0 .54-.2 1-.6 1.38-.394.373-.967.6-1.72.68v1.12h-.82v-1.11a5.6 5.6 0 0 1-1.4-.27c-.44-.147-.79-.333-1.05-.56l.45-1.01c.246.2.546.37.9.51.353.133.72.217 1.1.25v-2a7.963 7.963 0 0 1-1.19-.37 2.13 2.13 0 0 1-.79-.6c-.214-.267-.32-.617-.32-1.05 0-.54.196-1 .59-1.38.393-.38.963-.607 1.71-.68V9.8h.82v1.11c.373.02.736.083 1.09.19.36.107.673.247.94.42l-.41 1.01a4.162 4.162 0 0 0-1.62-.54v2.02a7.5 7.5 0 0 1 1.19.37c.32.133.586.333.8.6.22.26.33.607.33 1.04zm-4.15-3.09c0 .22.086.397.26.53.173.133.423.247.75.34v-1.78c-.34.053-.594.16-.76.32a.786.786 0 0 0-.25.59zm1.83 4.06c.353-.053.613-.157.78-.31a.73.73 0 0 0 .26-.57.637.637 0 0 0-.27-.54c-.18-.14-.437-.257-.77-.35v1.77z"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  }))));
};
CalendarTodayBlack.displayName = "CalendarTodayBlack";
CalendarTodayBlack.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var SwapHorizontalCircle = function SwapHorizontalCircle(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22 12c0-5.52-4.48-10-10-10S2 6.48 2 12s4.48 10 10 10 10-4.48 10-10zm-7-5.5l3.15 3.15c.2.2.2.51 0 .71L15 13.5V11h-4V9h4V6.5zm-9.15 7.85L9 17.5V15h4v-2H9v-2.5l-3.15 3.14c-.2.2-.2.51 0 .71z",
    fill: "#42A8D5"
  }));
};
SwapHorizontalCircle.displayName = "SwapHorizontalCircle";
SwapHorizontalCircle.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var DragIndicator = function DragIndicator(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 4c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm-2 8c0-1.1.9-2 2-2s2 .9 2 2-.9 2-2 2-2-.9-2-2zm2 8c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm8-14c0 1.1-.9 2-2 2s-2-.9-2-2 .9-2 2-2 2 .9 2 2zm-2 4c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm-2 8c0-1.1.9-2 2-2s2 .9 2 2-.9 2-2 2-2-.9-2-2z",
    fill: "#9da3a8"
  }));
};
DragIndicator.displayName = "DragIndicator";
DragIndicator.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var EventAvailable = function EventAvailable(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M16.53 11.06L15.47 10l-4.88 4.88-2.12-2.12-1.06 1.06L10.59 17l5.94-5.94zM19 3h-1V1h-2v2H8V1H6v2H5c-1.11 0-1.99.9-1.99 2L3 19a2 2 0 0 0 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V8h14v11z",
    fill: "#9da3a8"
  }));
};
EventAvailable.displayName = "EventAvailable";
EventAvailable.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var Event = function Event(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 3v1H8V3c0-.55-.45-1-1-1s-1 .45-1 1v1H5c-1.11 0-1.99.9-1.99 2L3 20a2 2 0 0 0 2 2h14c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2h-1V3c0-.55-.45-1-1-1s-1 .45-1 1zm0 10h-3c-.55 0-1 .45-1 1v3c0 .55.45 1 1 1h3c.55 0 1-.45 1-1v-3c0-.55-.45-1-1-1zM6 20h12c.55 0 1-.45 1-1V9H5v10c0 .55.45 1 1 1z",
    fill: "#000"
  }));
};
Event.displayName = "Event";
Event.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var Lock = function Lock(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 8.5h-1v-2c0-2.76-2.24-5-5-5s-5 2.24-5 5v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2v-10c0-1.1-.9-2-2-2zm-6 9c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zm-3-11v2h6v-2c0-1.66-1.34-3-3-3s-3 1.34-3 3z",
    fill: "#9da3a8"
  }));
};
Lock.displayName = "Lock";
Lock.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var Assignment = function Assignment(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19 4h-4.18C14.4 2.84 13.3 2 12 2c-1.3 0-2.4.84-2.82 2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm-7 0c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zM8 18h5c.55 0 1-.45 1-1s-.45-1-1-1H8c-.55 0-1 .45-1 1s.45 1 1 1zm8-4H8c-.55 0-1-.45-1-1s.45-1 1-1h8c.55 0 1 .45 1 1s-.45 1-1 1zm-8-4h8c.55 0 1-.45 1-1s-.45-1-1-1H8c-.55 0-1 .45-1 1s.45 1 1 1z",
    fill: "#9da3a8"
  }));
};
Assignment.displayName = "Assignment";
Assignment.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var NewReleases = function NewReleases(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.42 11.34l-1.86-2.12.26-2.81c.05-.5-.29-.96-.77-1.07l-2.76-.63-1.44-2.43a.997.997 0 0 0-1.25-.41L12 3 9.41 1.89c-.46-.2-1-.02-1.25.41L6.71 4.72l-2.75.62c-.49.11-.83.56-.78 1.07l.26 2.8-1.86 2.13c-.33.38-.33.94 0 1.32l1.86 2.12-.26 2.82c-.05.5.29.96.77 1.07l2.76.63 1.44 2.42c.26.43.79.61 1.26.41L12 21l2.59 1.11c.46.2 1 .02 1.25-.41l1.44-2.43 2.76-.63c.49-.11.82-.57.77-1.07l-.26-2.81 1.86-2.12c.34-.36.34-.92.01-1.3zM11 17v-2h2v2h-2zm0-5c0 .55.45 1 1 1s1-.45 1-1V8c0-.55-.45-1-1-1s-1 .45-1 1v4z",
    fill: "#9da3a8"
  }));
};
NewReleases.displayName = "NewReleases";
NewReleases.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var PlayArrow = function PlayArrow(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M6.927 6.82v10.36c0 .79.87 1.27 1.54.84l8.14-5.18a1 1 0 0 0 0-1.69l-8.14-5.17a.998.998 0 0 0-1.54.84z",
    fill: "#9da3a8"
  }));
};
PlayArrow.displayName = "PlayArrow";
PlayArrow.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var Stop = function Stop(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M8 6h8c1.1 0 2 .9 2 2v8c0 1.1-.9 2-2 2H8c-1.1 0-2-.9-2-2V8c0-1.1.9-2 2-2z",
    fill: "#9da3a8"
  }));
};
Stop.displayName = "Stop";
Stop.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var Feedback = function Feedback(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.995 2H4.005c-1.1 0-2 .9-2 2v18l3.99-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-7 10v2h-2v-2h2zm-1-2c.55 0 1-.45 1-1V7c0-.55-.45-1-1-1s-1 .45-1 1v2c0 .55.45 1 1 1z",
    fill: "#9da3a8"
  }));
};
Feedback.displayName = "Feedback";
Feedback.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var PresentToAll = function PresentToAll(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21 3H3c-1.11 0-2 .89-2 2v14c0 1.11.89 2 2 2h18c1.11 0 2-.89 2-2V5c0-1.11-.89-2-2-2zm-1 16.02H4c-.55 0-1-.45-1-1V5.98c0-.55.45-1 1-1h16c.55 0 1 .45 1 1v12.04c0 .55-.45 1-1 1zM8 12h2v4h4v-4h2l-3.64-3.65c-.2-.2-.51-.2-.71 0L8 12z",
    fill: "#9da3a8"
  }));
};
PresentToAll.displayName = "PresentToAll";
PresentToAll.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var HowToReg = function HowToReg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.697 11.964c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm1 8l-.86-.86a2.997 2.997 0 0 1 .02-4.26l.84-.82a9.34 9.34 0 0 0-1-.06c-2.67 0-8 1.34-8 4v2h9zm2.76-.22c.39.39 1.03.39 1.42 0l5.14-5.18c.38-.38.38-1 0-1.39l-.01-.01a.996.996 0 0 0-1.41 0l-4.43 4.46-1.37-1.37a.984.984 0 0 0-1.4 0l-.01.01a.99.99 0 0 0 0 1.39l2.07 2.09z",
    fill: "#9da3a8"
  }));
};
HowToReg.displayName = "HowToReg";
HowToReg.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var FilterList = function FilterList(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 7c0 .55.45 1 1 1h16c.55 0 1-.45 1-1s-.45-1-1-1H4c-.55 0-1 .45-1 1zm8 11h2c.55 0 1-.45 1-1s-.45-1-1-1h-2c-.55 0-1 .45-1 1s.45 1 1 1zm6-5H7c-.55 0-1-.45-1-1s.45-1 1-1h10c.55 0 1 .45 1 1s-.45 1-1 1z",
    fill: "#42A8D5"
  }));
};
FilterList.displayName = "FilterList";
FilterList.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var LinkOff = function LinkOff(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.119.63a.996.996 0 1 0-1.41 1.41l2.4 2.4c-1.94.8-3.27 2.77-3.09 5.04.21 2.64 2.57 4.59 5.21 4.59h2.82c.52 0 .95-.43.95-.95s-.43-.95-.95-.95h-2.89c-1.63 0-3.1-1.19-3.25-2.82A3.095 3.095 0 0 1 4.659 6l2.1 2.1c-.43.09-.76.46-.76.92v.1c0 .52.43.95.95.95h1.78l2.27 2.27v1.73h1.73l3.3 3.3a.996.996 0 1 0 1.41-1.41L2.119.63zm17.82 7.67c-.37-2.47-2.62-4.23-5.12-4.23h-2.87c-.52 0-.95.43-.95.95s.43.95.95.95h2.9c1.6 0 3.04 1.14 3.22 2.73.17 1.43-.64 2.69-1.85 3.22l1.4 1.4c1.63-1.02 2.64-2.91 2.32-5.02zm-6.89-.23c.52 0 .95.43.95.95v.1c0 .16-.05.31-.12.44l-1.49-1.49h.66z",
    fill: "#CED3D6"
  }));
};
LinkOff.displayName = "LinkOff";
LinkOff.defaultProps = {
  width: "20",
  height: "18",
  viewBox: "0 0 20 18",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var Contract = function Contract(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M13.265 4.914H5.756a1 1 0 1 0 0 2.001h7.51a1 1 0 0 0 1-1c-.005-.55-.45-1-1-1zM14.26 9.665a1 1 0 0 0-1-1H5.755a1 1 0 0 0 0 2.001h7.51c.55 0 .995-.445.995-1zM9.51 14.416a1 1 0 1 0 0-2H5.757a1 1 0 1 0 0 2h3.755z",
    fill: "#9da3a8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.067 17.816l-1.049.69v2.487H3.003V3.001h13.015v3.95l2.003-3.464V2c0-.55-.45-1.001-1.001-1.001H2.002C1.45 1 1 1.45 1 2v20a1 1 0 0 0 1.002 1H17.02a1 1 0 0 0 1.001-1v-5.512l-.48.825c-.117.205-.281.38-.474.503z",
    fill: "#9da3a8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.988 5.628c-.023-.088-.234-.901-1.505-1.632-1.277-.732-2.08-.515-2.167-.486a.495.495 0 0 0-.281.228l-6.262 10.825a.411.411 0 0 0-.064.222l-.234 3.909a.496.496 0 0 0 .773.444l3.268-2.153a.49.49 0 0 0 .158-.17L22.93 5.991a.52.52 0 0 0 .058-.363zm-8.481 11.778a3.914 3.914 0 0 0-.562-.374 3.873 3.873 0 0 0-.61-.293l.07-1.17c.264.035.651.14 1.143.421.492.287.773.568.937.773l-.978.643zM7.976 19.039c.035.199.264.263.422.327.146.065.328-.058.45-.117.762-.368 1.799.065 2.619.065.48 0 .48-.75 0-.75-.955 0-1.745-.24-2.694-.087a.464.464 0 0 0-.076-.228c-.176-.299-.405-.386-.627-.351-.018-.035-.03-.07-.053-.105a.345.345 0 0 0-.234-.164c.263-.457.433-.948.263-1.34-.052-.117-.205-.182-.322-.188-.503-.017-.931.51-1.253.826-.809.79-1.517 1.685-2.208 2.58-.293.38.357.755.65.38.609-.79 1.253-1.556 1.95-2.276-.17.275-.345.544-.533.802-.27.415.37.76.644.38a.83.83 0 0 1 .24-.234.926.926 0 0 1-.058.134h.006a.59.59 0 0 0-.041.088c-.17.422.457.615.685.293a2.33 2.33 0 0 0 .158-.258c0 .053 0 .135.012.223z",
    fill: "#9da3a8"
  }));
};
Contract.displayName = "Contract";
Contract.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var CreditCards = function CreditCards(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M21.256 5.989L9.337 3.519a.94.94 0 0 0-1.11.708L8 5.651 21.752 8.5l.226-1.424a.92.92 0 0 0-.722-1.087zM15.927 8.652a.967.967 0 0 0-1.183-.655l-2.3.624L7.025 7.5l-.596 2.753-3.724 1.01a.94.94 0 0 0-.67 1.156l2.1 7.393a.967.967 0 0 0 1.183.654l12.04-3.266a.94.94 0 0 0 .669-1.156l-.36-1.269 1.35.28a.955.955 0 0 0 1.129-.718l.854-3.946-4.864-1.006-.208-.733zM2.79 12.215a.176.176 0 0 1 .123-.214l3.332-.903 7.862-2.133.846-.23a.181.181 0 0 1 .219.12l.099.35.311 1.097L3.2 13.66l-.41-1.445zm14.527.194l.298-1.375a.394.394 0 0 1 .465-.296l1.407.292c.21.043.347.247.303.454l-.298 1.375a.393.393 0 0 1-.465.295l-1.407-.29a.385.385 0 0 1-.303-.455zm-.046 3.84a.167.167 0 0 1-.018.131.172.172 0 0 1-.106.083l-12.04 3.265a.181.181 0 0 1-.219-.12l-1.224-4.312 12.382-3.359.755 2.66.47 1.652z",
    fill: "#9da3a8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.53 16.834a.457.457 0 0 0-.562-.317l-1.635.454a.456.456 0 0 0-.317.56l.454 1.635c.067.242.32.385.56.317l1.636-.453a.457.457 0 0 0 .317-.561l-.454-1.635z",
    fill: "#9da3a8"
  }));
};
CreditCards.displayName = "CreditCards";
CreditCards.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var Destination = function Destination(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.421 10.233l-.388.469-4.974 6.013h5.572v1.848H2.063v-1.47L7.44 10.61H2.175V8.763h8.246v1.47zm4.865 9.803c-1.11-1.335-3.347-4.214-4.546-7.05l1.222-1.478a2 2 0 0 0 .46-1.275v-1.47a2 2 0 0 0-1.753-1.985 5.995 5.995 0 0 1 5.268-3.122c3.317 0 6 2.683 6 6 0 3.574-3.789 8.503-5.34 10.38a.851.851 0 0 1-1.312 0zm-1.492-10.38a2.144 2.144 0 1 0 4.287-.002 2.144 2.144 0 0 0-4.287.002z",
    fill: "#9da3a8"
  }));
};
Destination.displayName = "Destination";
Destination.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var Driver = function Driver(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M12.427 20.509l-3.794-.24c-3.11-.199-3.427-.508-3.938-3.794-.225-1.452-.816-5.818-.816-5.818-.156-1.319 1.746-1.631 1.94-.282 0 0 .542 4.182.775 5.566.312 1.872.575 2.196 2.47 2.315l3.48.22c1.366.088 1.228 2.12-.117 2.033zm3.057-5.719a1.721 1.721 0 0 0-1.3-.698l-1.673-.16c-.366-.034-.729-.068-1.095-.107-.137-.015-.282-.041-.419-.022l-.515-2.208-.045-.225.438.229c.229.118.484.168.74.145l3.374-.32a1.326 1.326 0 0 0-.252-2.639l-2.981.286-2.46-1.673a1.846 1.846 0 0 0-.392-.27l-.015-.009a1.707 1.707 0 0 0-1.072-.137 1.82 1.82 0 0 0-1.021.61c-.1.122-.187.27-.244.416a1.81 1.81 0 0 0-.088.995c.11.564.225 1.132.336 1.696.152.763.3 1.521.453 2.284 0 0 .351 2.73.717 3.381a.47.47 0 0 0 .065.096c.381.457.77.812 1.403.842l4.468.218 2.68 4.567c.244.26.568.396.896.412a1.325 1.325 0 0 0 1.026-2.234c-.004.007-3.024-5.475-3.024-5.475zm4.518-6.634a.493.493 0 0 0-.694-.03l-4.777 4.384a.493.493 0 0 0 .305.854.468.468 0 0 0 .355-.13l4.777-4.384a.49.49 0 0 0 .034-.694zM7.15 6.08A2.287 2.287 0 0 0 9.438 3.79 2.288 2.288 0 0 0 7.15 1.5 2.29 2.29 0 0 0 4.86 3.791 2.293 2.293 0 0 0 7.15 6.08z",
    fill: "#9da3a8"
  }));
};
Driver.displayName = "Driver";
Driver.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var Ellipse = function Ellipse(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("circle", {
    cx: "3",
    cy: "3",
    r: "3",
    fill: "#9da3a8"
  }));
};
Ellipse.displayName = "Ellipse";
Ellipse.defaultProps = {
  width: "6",
  height: "6",
  viewBox: "0 0 6 6",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var Exit = function Exit(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M18 14.5V12h-6.25V9.5H18V7l3.75 3.75L18 14.5zm-1.25-1.25v5H10.5V22L3 18.25V2h13.75v6.25H15.5v-5h-10l5 2.5V17h5v-3.75h1.25z",
    fill: "#9da3a8"
  }));
};
Exit.displayName = "Exit";
Exit.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var Filter = function Filter(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M9.864 11.506c.19.205.293.474.293.752v8.185c0 .492.594.742.946.396l2.284-2.617c.305-.366.474-.548.474-.91v-5.053c0-.277.105-.546.292-.752l6.552-7.109A.834.834 0 0 0 20.092 3H3.925a.833.833 0 0 0-.613 1.398l6.552 7.108z",
    fill: "#9da3a8"
  }));
};
Filter.displayName = "Filter";
Filter.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var Group = function Group(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M5.178 5.961a1.972 1.972 0 1 0 0-3.945 1.972 1.972 0 0 0 0 3.945zM2.978 12.872h.196v3.912c0 .538.44.978.978.978h2.053a.98.98 0 0 0 .978-.978v-.228a2.472 2.472 0 0 1-.293-1.141v-5.118a2.44 2.44 0 0 1 1.467-2.233v-.392a.98.98 0 0 0-.978-.978H2.978A.98.98 0 0 0 2 7.672v4.222a.97.97 0 0 0 .978.978zM18.838 5.961a1.972 1.972 0 1 0 0-3.945 1.972 1.972 0 0 0 0 3.945zM15.643 7.656v.391a2.44 2.44 0 0 1 1.467 2.233v5.102c0 .408-.098.8-.293 1.141v.229c0 .538.44.978.978.978h2.054a.98.98 0 0 0 .978-.978V12.84h.195a.98.98 0 0 0 .978-.978V7.656a.98.98 0 0 0-.978-.978h-4.4a.98.98 0 0 0-.979.978zM8.373 10.297v5.117c0 .539.44.979.978.979h.375v4.613c0 .538.44.978.978.978h2.624a.98.98 0 0 0 .979-.978v-4.63h.374a.98.98 0 0 0 .978-.977v-5.102a.98.98 0 0 0-.978-.978h-5.33a.97.97 0 0 0-.978.978zM12.008 8.504a2.266 2.266 0 1 0 0-4.532 2.266 2.266 0 0 0 0 4.532z",
    fill: "#9da3a8"
  }));
};
Group.displayName = "Group";
Group.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var Invoices = function Invoices(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M19.377 1H3.695a.644.644 0 0 0-.645.645v20.71a.644.644 0 0 0 .999.539l1.606-1.056 1.606 1.056c.215.14.494.14.709 0l1.606-1.056 1.606 1.056c.215.14.493.14.708 0l1.607-1.056 1.606 1.056c.215.14.493.14.708 0l1.607-1.056 1.606 1.056a.643.643 0 0 0 .998-.538V1.645A.646.646 0 0 0 19.377 1zM6.273 3.578a.645.645 0 0 1 0 1.29.645.645 0 0 1 0-1.29zm0 2.578a.645.645 0 1 1-.644.645c0-.355.288-.645.644-.645zm2.019 11.982v.35a.645.645 0 0 1-1.289 0v-.3h-.387a.645.645 0 0 1 0-1.29h1.246c.449 0 .516-.404.516-.644s-.068-.645-.516-.645H7.5l-.034-.001-.034.001c-1.046 0-1.805-.813-1.805-1.933 0-.96.558-1.694 1.375-1.885v-.35a.644.644 0 1 1 1.289 0v.301h.387a.644.644 0 1 1 0 1.29H7.433c-.449 0-.516.403-.516.644 0 .24.067.644.516.644l.034.002.034-.002h.36c1.046 0 1.805.814 1.805 1.934.001.96-.556 1.694-1.374 1.884zm8.507.35h-5.242a.645.645 0 0 1 0-1.289H16.8a.645.645 0 0 1 0 1.29zm0-2.879h-5.242a.645.645 0 0 1 0-1.289H16.8a.645.645 0 0 1 0 1.29zm0-2.879h-5.242a.645.645 0 0 1 0-1.289H16.8a.644.644 0 1 1 0 1.29zm0-5.285H8.851a.645.645 0 0 1 0-1.289h7.948a.645.645 0 0 1 0 1.29zm0-2.578H8.851a.645.645 0 0 1 0-1.289h7.948a.645.645 0 0 1 0 1.29z",
    fill: "#9da3a8"
  }));
};
Invoices.displayName = "Invoices";
Invoices.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var Loading = function Loading(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M22.66 10.747l-1.957-2.612a.863.863 0 0 0-.68-.34h-2.901c-.28 0-.502.23-.502.502v5.36h-6.26a2.55 2.55 0 0 0-1.821-.767 2.53 2.53 0 0 0-1.812.766H4.285v.085c0 .936.766 1.702 1.702 1.702a2.549 2.549 0 0 0 2.552 2.551 2.549 2.549 0 0 0 2.552-2.551h5.104a2.549 2.549 0 0 0 2.552 2.551 2.549 2.549 0 0 0 2.552-2.551h.85c.468 0 .851-.383.851-.851v-2.824c0-.366-.119-.724-.34-1.021zM8.539 16.302a.853.853 0 0 1-.851-.851c0-.468.383-.85.85-.85.469 0 .851.382.851.85 0 .468-.382.85-.85.85zm10.208 0a.853.853 0 0 1-.851-.851c0-.468.383-.85.85-.85.469 0 .851.382.851.85 0 .468-.382.85-.85.85zm-.851-5.104V9.07h2.127l1.667 2.127h-3.794z",
    fill: "#9da3a8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.263 6c1.88 0 3.572.774 4.797 2.008l1.285-1.285a.425.425 0 0 1 .723.306v3.65a.421.421 0 0 1-.425.425h-3.65a.421.421 0 0 1-.298-.723l1.183-1.182A5.142 5.142 0 0 0 7.263 7.7a5.099 5.099 0 0 0-4.611 2.918c-.136.29-.4.485-.715.485h-.161a.78.78 0 0 1-.698-1.123A6.798 6.798 0 0 1 7.263 6z",
    fill: "#9da3a8"
  }));
};
Loading.displayName = "Loading";
Loading.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var Open = function Open(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 18c0 .55.45 1 1 1h12c.55 0 1-.45 1-1v-5c0-.55.45-1 1-1s1 .45 1 1v6c0 1.1-.9 2-2 2H5c-1.1 0-2-.9-2-2V5a2 2 0 0 1 2-2h6c.55 0 1 .45 1 1s-.45 1-1 1H6c-.55 0-1 .45-1 1v12zM15 5c-.55 0-1-.45-1-1s.45-1 1-1h5c.55 0 1 .45 1 1v5c0 .55-.45 1-1 1s-1-.45-1-1V6.41l-9.13 9.13a.996.996 0 1 1-1.41-1.41L17.59 5H15z",
    fill: "#9da3a8"
  }));
};
Open.displayName = "Open";
Open.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var OpenFile = function OpenFile(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M6.937 12.05c.803-.372 1.572-.557 2.306-.557h9.742V9.62c0-.719-.257-1.335-.772-1.85a2.523 2.523 0 0 0-1.85-.773h-6.37v-.375c0-.719-.257-1.335-.775-1.85A2.519 2.519 0 0 0 7.37 4H3.623c-.719 0-1.335.257-1.85.772A2.523 2.523 0 0 0 1 6.622v11.24c0 .031.002.081.005.148.004.066.008.115.008.145l.059-.07 3.945-4.636c.476-.562 1.115-1.028 1.92-1.4z",
    fill: "#9da3a8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.69 13.145a1.578 1.578 0 0 0-.709-.152H9.245c-.516 0-1.076.138-1.682.415-.605.276-1.074.614-1.41 1.013l-3.934 4.636c-.24.273-.363.532-.363.773 0 .233.104.4.31.503.207.102.445.152.71.152h12.738c.516 0 1.075-.138 1.68-.415.605-.276 1.076-.614 1.412-1.013l3.934-4.636c.242-.273.363-.532.363-.773a.523.523 0 0 0-.313-.503z",
    fill: "#9da3a8"
  }));
};
OpenFile.displayName = "OpenFile";
OpenFile.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var Operator = function Operator(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M12 13.28c1.38 0 4.624-1.661 4.624-5.64C16.624 4.525 16.204 2 12 2S7.376 4.525 7.376 7.64c0 3.979 3.244 5.64 4.624 5.64zM8.067 6.699c.325-.629 1.027-1.355 2.538-1.322 0 0 .901 2.184 5.322 1.203.018.35.024.705.024 1.06 0 1.945-.859 3.15-1.58 3.818-.907.843-1.915 1.148-2.371 1.148-.456 0-1.464-.305-2.372-1.148-.72-.668-1.58-1.873-1.58-3.818 0-.315.005-.63.019-.941z",
    fill: "#9da3a8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.585 19.064c-.236-1.468-.722-3.36-1.697-4.031-.666-.46-2.988-1.7-3.98-2.23l-.017-.01a.324.324 0 0 0-.353.032 4.212 4.212 0 0 1-1.691.817.324.324 0 0 0-.233.201L12 15.461l-.614-1.618a.324.324 0 0 0-.232-.201 4.212 4.212 0 0 1-1.692-.817.324.324 0 0 0-.353-.031c-.98.524-3.33 1.79-3.994 2.237-1.122.756-1.613 3.492-1.7 4.033a.325.325 0 0 0 .015.16C3.47 19.336 4.5 22 12 22s8.53-2.663 8.57-2.777a.325.325 0 0 0 .015-.16zm-3.456-.896l-1.468.457-1.468-.457v-.79h2.936v.79z",
    fill: "#9da3a8"
  }));
};
Operator.displayName = "Operator";
Operator.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var Origin = function Origin(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.816 18.09l-4.162-9.306A5.997 5.997 0 0 1 16.532 4c3.317 0 6 2.683 6 6 0 3.574-3.789 8.503-5.34 10.38a.851.851 0 0 1-1.312 0 41.04 41.04 0 0 1-.917-1.146 2 2 0 0 0-.147-1.143zM14.389 10a2.144 2.144 0 1 0 4.287-.002 2.144 2.144 0 0 0-4.287.002zM5.192 16.807h4.55l.868 2.1h2.38l-4.382-9.8h-2.24L2 18.907h2.324l.868-2.1zm2.282-5.474l1.554 3.752H5.92l1.554-3.752z",
    fill: "#9da3a8"
  }));
};
Origin.displayName = "Origin";
Origin.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var Return = function Return(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M19.352 4.16C17.912 2.72 15.938 2 13.963 2h-.007c-1.975 0-3.941.72-5.382 2.16L5.323 7.412v-3.09H3v6.97h6.968v-2.27H7.05l3.167-3.212c1.997-2.006 5.49-2.006 7.487 0 .999.998 1.548 2.33 1.548 3.794 0 1.37-.55 2.694-1.548 3.7l-1.75 1.75 1.641 1.642 1.75-1.742c1.448-1.456 2.238-3.368 2.238-5.35 0-2.091-.79-4.004-2.23-5.444zM14.957 16.058l-1.645 1.64 1.641 1.645 1.645-1.64-1.641-1.645zM10.657 20.35l.232.233L12.3 22l1.409-1.417.232-.232-1.641-1.642-1.642 1.642z",
    fill: "#9da3a8"
  }));
};
Return.displayName = "Return";
Return.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var Services = function Services(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M21.466 14.979L16.9 20.207c-.6.707-1.478 1.093-2.421 1.093H7.623l-1.179 1.2-4.243-4.136 3.043-3.021a4.678 4.678 0 0 1 4.8-1.093l.665.236h4.114c.728 0 1.307.6 1.286 1.328-.022.707-.643 1.265-1.35 1.265h-2.465a.498.498 0 0 0-.493.492c0 .279.236.493.493.493h2.486c1.264 0 2.314-1.007 2.357-2.228v-.022l2.293-2.571a1.401 1.401 0 0 1 1.907-.193c.557.493.622 1.371.129 1.929zM7.623 7.8v-.75c0-.321.236-.621.557-.664l.879-.15c.107-.386.257-.772.45-1.115l-.515-.728a.684.684 0 0 1 .086-.879l.536-.535a.684.684 0 0 1 .878-.086l.729.514a5.059 5.059 0 0 1 1.114-.45l.15-.878c.064-.343.343-.579.664-.579h.772c.321 0 .621.236.664.557l.15.879c.386.128.772.278 1.114.471l.729-.514a.684.684 0 0 1 .879.086l.535.535c.236.236.257.6.086.879l-.514.728c.193.343.343.708.45 1.115l.878.15a.686.686 0 0 1 .557.664v.75c0 .321-.235.621-.557.664l-.9.15a5.062 5.062 0 0 1-.45 1.115l.515.728a.684.684 0 0 1-.086.879l-.536.535a.711.711 0 0 1-.878.086l-.708-.536a4.661 4.661 0 0 1-1.114.45l-.15.879a.686.686 0 0 1-.664.557h-.75c-.322 0-.622-.236-.664-.557l-.15-.879a5.05 5.05 0 0 1-1.115-.45l-.75.515a.684.684 0 0 1-.878-.086l-.536-.536a.711.711 0 0 1-.086-.878l.515-.729a4.666 4.666 0 0 1-.45-1.114l-.879-.15a.647.647 0 0 1-.557-.643zm3.878-.386c0 1.115.9 2.036 2.036 2.036 1.136 0 2.036-.9 2.036-2.036a2.035 2.035 0 1 0-4.072 0z",
    fill: "#9da3a8"
  }));
};
Services.displayName = "Services";
Services.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var Signature = function Signature(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M17.705 2.77l-4.888 4.153a.437.437 0 0 1-.567-.667l4.89-4.152a.437.437 0 0 1 .565.666zM21.396 22H18.74c-.286 0-.562-.084-.8-.242l-1.119-.746a.273.273 0 0 0-.274-.018l-1.373.687a1.435 1.435 0 0 1-1.592-.204l-1.336-1.169a.275.275 0 0 0-.36 0l-1.526 1.335c-.262.23-.599.356-.948.356H2.153a.583.583 0 0 1 0-1.166h7.259c.066 0 .13-.024.18-.067l1.526-1.336a1.444 1.444 0 0 1 1.896 0L14.35 20.6c.084.073.203.089.302.038l1.374-.686a1.442 1.442 0 0 1 1.442.09l1.12.746c.045.03.098.047.152.047h2.656a.583.583 0 0 1 0 1.166zM5.808 14.21L8.264 17.1a.146.146 0 0 1-.016.206l-1 .85-4.801 1.758a.292.292 0 0 1-.354-.417l2.51-4.456 1-.849a.146.146 0 0 1 .205.017zM8.93 16.535l-2.455-2.892a.146.146 0 0 1 .017-.205l10-8.494a.146.146 0 0 1 .205.017l2.456 2.892a.146.146 0 0 1-.017.205l-10 8.494a.146.146 0 0 1-.205-.017zM21.914 5.699l-1.889 1.604a.146.146 0 0 1-.205-.016l-2.456-2.892a.146.146 0 0 1 .016-.206l1.889-1.604a1.458 1.458 0 0 1 2.055.167l.757.892a1.458 1.458 0 0 1-.167 2.055z",
    fill: "#9da3a8"
  }));
};
Signature.displayName = "Signature";
Signature.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var Tickets = function Tickets(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M15.217 15.472h2.473l2.446 3.684H3.863l2.445-3.684h2.476a27.5 27.5 0 0 1-.653-1h-2.36L2 20.156h20l-3.772-5.684h-2.359c-.214.345-.433.68-.65 1z",
    fill: "#9da3a8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.049 8.795a4.947 4.947 0 0 1 4.95-4.95 4.947 4.947 0 0 1 4.95 4.95c0 2.949-3.125 7.015-4.405 8.564-.283.34-.8.34-1.082 0-1.287-1.549-4.413-5.615-4.413-8.564zm3.182 0a1.769 1.769 0 1 0 3.538-.002 1.769 1.769 0 0 0-3.538.002z",
    fill: "#9da3a8"
  }));
};
Tickets.displayName = "Tickets";
Tickets.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var Tools = function Tools(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M5.698 22a3.706 3.706 0 0 0 3.415-5.126l.017-.015 3.254-3.266 3.054 3.064-.627.628c-.198.2-.307.464-.307.746a1.052 1.052 0 0 0 1.05 1.054c.168 0 .33-.041.475-.115l2.577 2.586c.202.203.471.314.759.314.22 0 .43-.066.609-.189.2.117.43.186.678.186a1.353 1.353 0 0 0 1.156-2.047 1.075 1.075 0 0 0-.16-1.316l-2.577-2.585a1.052 1.052 0 0 0-.937-1.53c-.28 0-.544.11-.743.308l-.626.628-3.053-3.064 3.356-3.367c.41.162.852.248 1.307.248.95 0 1.845-.371 2.517-1.046a3.59 3.59 0 0 0 .917-3.467.518.518 0 0 0-.49-.379.523.523 0 0 0-.37.159S19.74 5.61 19.33 6.022a.165.165 0 0 1-.048.006h-.021l-.038-.006c-.406-.037-.92-.11-1.129-.171-.058-.2-.133-.69-.173-1.151l.005-.003-.009-.03c0-.018.006-.054.04-.089.422-.422 1.574-1.587 1.574-1.587a.514.514 0 0 0 .148-.502.522.522 0 0 0-.373-.365A3.563 3.563 0 0 0 18.375 2c-.951 0-1.844.372-2.517 1.046a3.553 3.553 0 0 0-1.042 2.526c0 .456.086.9.247 1.31l-3.356 3.368-4.264-4.28c.047-.117.083-.233.101-.337l.101-.577a1.026 1.026 0 0 0-.515-1.038l-3.492-1.8a.982.982 0 0 0-.448-.104.939.939 0 0 0-.665.255c-.269.269-.334.759-.15 1.117L4.17 6.99c.16.312.524.53.887.53.05 0 .1-.005.147-.013l.575-.1c.104-.02.22-.055.336-.103l4.265 4.28-3.255 3.265-.015.016a3.657 3.657 0 0 0-1.413-.282A3.707 3.707 0 0 0 2 18.292 3.708 3.708 0 0 0 5.698 22zm-.388-4.888l1.21.255.384 1.182-.826.927-1.21-.255-.384-1.182.826-.927z",
    fill: "#9da3a8"
  }));
};
Tools.displayName = "Tools";
Tools.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var Unloading = function Unloading(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M1 11.768v2.833c0 .468.383.85.85.85h.851a2.549 2.549 0 0 0 2.553 2.553 2.549 2.549 0 0 0 2.552-2.552h5.104a2.549 2.549 0 0 0 2.553 2.552 2.549 2.549 0 0 0 2.552-2.552c.936 0 1.701-.766 1.701-1.702v-.093h-2.433a2.55 2.55 0 0 0-1.82-.766c-.715 0-1.353.298-1.821.766H7.38v-5.36c0-.28-.23-.502-.502-.502H3.978a.862.862 0 0 0-.681.34L1.34 10.747c-.22.298-.34.655-.34 1.021zm13.612 3.684c0-.468.383-.851.85-.851.468 0 .851.383.851.85 0 .468-.383.851-.85.851a.853.853 0 0 1-.851-.85zm-10.21 0c0-.468.384-.851.852-.851.468 0 .85.383.85.85 0 .468-.382.851-.85.851a.853.853 0 0 1-.851-.85zM2.31 11.198l1.668-2.127h2.126v2.127H2.31z",
    fill: "#9da3a8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.194 6c1.88 0 3.573.774 4.798 2.008l1.285-1.285A.425.425 0 0 1 23 7.03v3.65a.421.421 0 0 1-.425.425h-3.65a.421.421 0 0 1-.298-.723L19.81 9.2A5.143 5.143 0 0 0 16.194 7.7a5.099 5.099 0 0 0-4.61 2.919c-.137.289-.4.484-.715.484h-.162a.78.78 0 0 1-.698-1.123A6.798 6.798 0 0 1 16.194 6z",
    fill: "#9da3a8"
  }));
};
Unloading.displayName = "Unloading";
Unloading.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var CashAccount = function CashAccount(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M18.22 13.212c-.247-.193-2.818-3.046-3.512-3.45V2.357c0-.752-.61-1.357-1.358-1.357H6.357C5.605 1 5 1.61 5 2.357v12.965c0 .752.61 1.357 1.357 1.357h3.047l-.126-1.066-.107-.094H7.827c.045-.18.058-.377.022-.578a1.384 1.384 0 0 0-1.693-1.098V3.751A1.376 1.376 0 0 0 7.76 2.156h4.175a1.373 1.373 0 0 0 1.604 1.595v12.682c-.476-.35-1.004-1.443-1.004-1.443s-.26-2.907-1.734-2.907c-.04 0-.076 0-.116.004 0 0-1.116.094-.193 3.284l.412 3.543s.462 1.922 1.734 3.253v.394c0 .21.17.385.385.385h4.144a.383.383 0 0 0 .38-.34c.149-1.38.722-6.51 1.058-7.289a1.47 1.47 0 0 0 .116-.385c.077-.439.104-1.245-.501-1.72z",
    fill: "#9da3a8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.828 4.597a.824.824 0 1 1-1.648 0 .824.824 0 0 1 1.648 0zM6.877 8.934c0 1.42.994 2.607 2.325 2.907.04-.076.08-.143.13-.215.439-.64 1.035-.757 1.236-.775a2.292 2.292 0 0 1 1.321.255c.579-.542.942-1.317.942-2.172a2.977 2.977 0 1 0-5.954 0zm1.192-.265c.179 0 .183 0 .21-.179a1.77 1.77 0 0 1 .117-.399c.031-.071.08-.098.152-.076.112.032.22.063.331.099.103.031.117.067.072.166a1.232 1.232 0 0 0-.125.631.407.407 0 0 0 .036.166c.085.193.295.22.425.058a1.02 1.02 0 0 0 .152-.273c.072-.17.14-.34.224-.497.283-.511.923-.65 1.362-.287.157.13.264.3.318.497.023.085.068.126.157.121.09-.004.175 0 .264 0 .081 0 .121.04.121.117.005.094.005.188 0 .282 0 .085-.049.12-.13.12h-.192c-.144 0-.148.005-.17.144a1.815 1.815 0 0 1-.144.506c-.063.126-.094.14-.224.103-.098-.026-.197-.053-.291-.085-.112-.036-.125-.067-.072-.17.094-.175.144-.363.17-.56a.647.647 0 0 0-.049-.367c-.094-.22-.35-.256-.501-.067a.758.758 0 0 0-.121.21c-.085.193-.148.394-.256.574-.174.295-.416.479-.775.456-.403-.022-.658-.255-.793-.622-.053-.153-.053-.153-.215-.157h-.16c-.122-.004-.144-.022-.144-.143v-.112c-.005-.251-.005-.251.25-.256z",
    fill: "#9da3a8"
  }));
};
CashAccount.displayName = "CashAccount";
CashAccount.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var Export = function Export(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M21.282 21.264V8.246a.733.733 0 0 0-.233-.54l-5.926-5.51A.761.761 0 0 0 14.62 2H5.454a.738.738 0 0 0-.736.736v8.22c0 .406.33.737.736.737a.738.738 0 0 0 .736-.736V3.472h7.485v5.644c0 .405.331.737.736.737h5.276c.037 0 .086 0 .123-.013v10.688H6.19v-2.945a.738.738 0 0 0-.736-.736.738.738 0 0 0-.736.736v3.68c0 .406.33.737.736.737h15.092c.405 0 .736-.33.736-.736zM15.148 4.233l4.454 4.147h-4.454V4.233z",
    fill: "#9da3a8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 14.147c0 .405.331.737.736.737h7.669l-2.369 2.11a.738.738 0 1 0 .982 1.105l3.829-3.411a.746.746 0 0 0 0-1.104l-3.829-3.412a.739.739 0 0 0-.981 1.104l2.405 2.136H3.736a.737.737 0 0 0-.736.735z",
    fill: "#9da3a8"
  }));
};
Export.displayName = "Export";
Export.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var Inquiry = function Inquiry(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M15.241 9.926a.72.72 0 0 0-.72-.72H7.099a.72.72 0 1 0 0 1.44h7.422a.72.72 0 0 0 .72-.72zM6.758 11.992c-.205 0-.372.344-.372.768 0 .425.167.769.372.769h2.33c.206 0 .372-.344.372-.769 0-.424-.166-.768-.372-.768h-2.33z",
    fill: "#9da3a8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.792 19.005h-2.41a1.443 1.443 0 0 1-1.44-1.441V4.882c0-.794.646-1.44 1.44-1.44h8.86c.794 0 1.44.646 1.44 1.44v4.432a.72.72 0 1 0 1.441 0V4.882A2.886 2.886 0 0 0 15.241 2H6.382A2.886 2.886 0 0 0 3.5 4.882v12.682a2.886 2.886 0 0 0 2.882 2.882h2.41a.72.72 0 1 0 0-1.44z",
    fill: "#9da3a8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.52 6.323H7.1a.72.72 0 1 0 0 1.441h7.422a.72.72 0 1 0 0-1.44z",
    fill: "#9da3a8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.647 22a5.366 5.366 0 1 0 0-10.732 5.366 5.366 0 0 0 0 10.732zm-2.05-7.789c-.12.214-.1.371.061.473l.487.31c.173.112.31.082.412-.088.105-.173.24-.32.403-.44.164-.12.378-.18.644-.18.3 0 .507.07.62.208.118.136.177.329.177.58 0 .24-.24.61-.723 1.111-.479.5-.718 1.004-.718 1.51v.14c0 .2.1.3.301.3h.695c.201 0 .301-.1.301-.3v-.075c0-.327.255-.742.765-1.246.513-.506.769-.977.769-1.413 0-.575-.175-1.027-.524-1.358-.345-.33-.884-.495-1.617-.495-.537 0-.982.105-1.334.315-.352.21-.591.426-.718.648zm1.335 5.49c0 .232.108.348.325.348h.704c.216 0 .324-.116.324-.347v-.621c0-.232-.108-.348-.324-.348h-.704c-.217 0-.325.116-.325.348v.62z",
    fill: "#9da3a8"
  }));
};
Inquiry.displayName = "Inquiry";
Inquiry.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var Inventory = function Inventory(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M18.239 3.67h-1.862a1.33 1.33 0 0 0-1.254-.835H13.78A2.273 2.273 0 0 0 12.008 2c-.7 0-1.35.315-1.771.835H8.892a1.33 1.33 0 0 0-1.254.835H5.777C4.795 3.67 4 4.415 4 5.335v15C4 21.255 4.795 22 5.777 22h12.446c.982 0 1.777-.75 1.777-1.665v-15c.02-.92-.78-1.665-1.761-1.665zM8.017 19.5c-.736 0-1.334-.56-1.334-1.25S7.281 17 8.017 17c.736 0 1.334.56 1.334 1.25s-.603 1.25-1.334 1.25zm0-4.165c-.736 0-1.334-.56-1.334-1.25s.598-1.25 1.334-1.25c.736 0 1.334.56 1.334 1.25s-.603 1.25-1.334 1.25zm0-4.165c-.736 0-1.334-.56-1.334-1.25s.598-1.25 1.334-1.25c.736 0 1.334.56 1.334 1.25s-.603 1.25-1.334 1.25zM8.46 4.5v-.415c0-.23.197-.415.443-.415h1.579c.16 0 .304-.08.384-.205.245-.39.672-.625 1.147-.625s.902.235 1.147.625c.08.13.224.205.384.205h1.58c.245 0 .442.185.442.415V4.5c0 .46-.4.835-.89.835H9.35c-.49 0-.891-.375-.891-.835zm8.445 14.17H11.57c-.245 0-.443-.185-.443-.415 0-.23.198-.415.443-.415h5.335c.246 0 .443.185.443.415 0 .23-.197.415-.443.415zm0-4.17H11.57c-.245 0-.443-.185-.443-.415 0-.23.198-.415.443-.415h5.335c.246 0 .443.185.443.415 0 .23-.197.415-.443.415zm0-4.165H11.57c-.245 0-.443-.185-.443-.415 0-.23.198-.415.443-.415h5.335c.246 0 .443.185.443.415 0 .23-.197.415-.443.415z",
    fill: "#9da3a8"
  }));
};
Inventory.displayName = "Inventory";
Inventory.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var Next = function Next(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M9.8 16.89l5.77-4.07c.56-.4.56-1.24 0-1.63L9.8 7.11c-.67-.46-1.58.01-1.58.82v8.14c0 .81.91 1.28 1.58.82z",
    fill: "#9da3a8"
  }));
};
Next.displayName = "Next";
Next.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var Previous = function Previous(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M8.428 12.82l5.77 4.07c.66.47 1.58-.01 1.58-.82V7.93c0-.81-.91-1.28-1.58-.82l-5.77 4.07a1 1 0 0 0 0 1.64z",
    fill: "#9da3a8"
  }));
};
Previous.displayName = "Previous";
Previous.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var WorkOrder = function WorkOrder(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.179 9.936a3 3 0 0 0 0 4.242l7.757 7.758a3 3 0 0 0 4.243 0l7.757-7.758a3 3 0 0 0 0-4.242l-7.757-7.757a3 3 0 0 0-4.243 0L2.179 9.936zm8.467 5.53a2.008 2.008 0 0 1-2.002 2.008 2.009 2.009 0 1 1 .768-3.87.128.128 0 0 1 .005-.004l1.763-1.77-2.31-2.317a.928.928 0 0 1-.182.055l-.312.055a.556.556 0 0 1-.56-.28l-.973-1.898a.546.546 0 0 1 .082-.605.509.509 0 0 1 .36-.138c.087 0 .17.02.243.057l1.891.975c.194.1.317.346.28.562l-.055.312a.935.935 0 0 1-.055.183l2.31 2.318 1.818-1.824a1.938 1.938 0 0 1-.134-.71c0-.517.2-1.003.564-1.368a1.914 1.914 0 0 1 1.868-.5c.1.028.177.103.202.198a.278.278 0 0 1-.08.272l-.852.86a.069.069 0 0 0-.022.048l.005.017h-.003c.022.25.062.516.094.624.113.033.391.073.611.093l.02.003h.012a.089.089 0 0 0 .026-.003c.222-.223.876-.874.876-.874a.283.283 0 0 1 .2-.086.28.28 0 0 1 .267.206 1.945 1.945 0 0 1-.497 1.878 1.922 1.922 0 0 1-2.071.432l-1.819 1.824 1.654 1.66.34-.341a.566.566 0 0 1 .804 0 .57.57 0 0 1 .105.662l1.397 1.4a.58.58 0 0 1 .086.713.733.733 0 0 1-.626 1.109.724.724 0 0 1-.368-.1.578.578 0 0 1-.74-.069l-1.396-1.4a.565.565 0 0 1-.66-.105.57.57 0 0 1 0-.808l.34-.34-1.655-1.66-1.763 1.77-.005.004a.055.055 0 0 0-.003.003c.097.237.152.496.152.768zm-1.557-.502l-.656-.138-.447.502.208.64.656.139.447-.502-.208-.64z",
    fill: "#000"
  }));
};
WorkOrder.displayName = "WorkOrder";
WorkOrder.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var DeliveryTicket = function DeliveryTicket(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.5 1.5a3 3 0 0 0-3 3v15a3 3 0 0 0 3 3h15a3 3 0 0 0 3-3v-15a3 3 0 0 0-3-3h-15zm11.149 9.67H6.34a.836.836 0 0 0-.834.834c0 .459.375.834.834.834h9.308l-4.067 4.066a.83.83 0 1 0 1.175 1.175l5.492-5.492a.83.83 0 0 0 0-1.175l-5.492-5.491a.83.83 0 0 0-1.175 0 .84.84 0 0 0 0 1.183l4.067 4.067z",
    fill: "#9da3a8"
  }));
};
DeliveryTicket.displayName = "DeliveryTicket";
DeliveryTicket.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var PickupTicket = function PickupTicket(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.07 2.358a2.928 2.928 0 0 0-4.14 0L2.357 9.929a2.928 2.928 0 0 0 0 4.142l7.571 7.571a2.928 2.928 0 0 0 4.142 0l7.571-7.571a2.928 2.928 0 0 0 0-4.142l-7.571-7.571zM8.352 12.829h9.308a.836.836 0 0 0 .834-.833.836.836 0 0 0-.834-.834H8.351l4.067-4.066a.83.83 0 1 0-1.175-1.175L5.75 11.412a.83.83 0 0 0 0 1.175l5.492 5.492a.83.83 0 0 0 1.175 0 .84.84 0 0 0 0-1.183L8.35 12.829z",
    fill: "#9da3a8"
  }));
};
PickupTicket.displayName = "PickupTicket";
PickupTicket.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var TaskTicket = function TaskTicket(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.763 2.712a3 3 0 0 0-3.526 0L2.899 8.044a3 3 0 0 0-1.09 3.354l2.803 8.626a3 3 0 0 0 2.853 2.073h9.07a3 3 0 0 0 2.853-2.073l2.803-8.626a3 3 0 0 0-1.09-3.354l-7.338-5.332zm1.664 4.957l3.271 3.271a.514.514 0 0 1 0 .737l-3.27 3.261v-2.596h-4.155v-2.077h4.154V7.669zM9.196 19.092l-3.271-3.271a.514.514 0 0 1 0-.737l3.271-3.261v2.596h4.154v2.077H9.196v2.596z",
    fill: "#9da3a8"
  }));
};
TaskTicket.displayName = "TaskTicket";
TaskTicket.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var Widgets = function Widgets(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.249 5.086l4.25-4.24c.39-.39 1.03-.39 1.42 0l4.24 4.24c.39.39.39 1.02 0 1.41l-4.25 4.25a.996.996 0 0 1-1.41 0l-4.25-4.25a.996.996 0 0 1 0-1.41zm-8.7-2.64v6c0 .55.45 1 1 1h6c.55 0 1-.45 1-1v-6c0-.55-.45-1-1-1h-6c-.55 0-1 .45-1 1zm7 17h-6c-.55 0-1-.45-1-1v-6c0-.55.45-1 1-1h6c.55 0 1 .45 1 1v6c0 .55-.45 1-1 1zm3-1v-6c0-.55.45-1 1-1h6c.55 0 1 .45 1 1v6c0 .55-.45 1-1 1h-6c-.55 0-1-.45-1-1z",
    fill: "#696F74"
  }));
};
Widgets.displayName = "Widgets";
Widgets.defaultProps = {
  height: "24",
  width: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var HeadsetMic = function HeadsetMic(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M11.4 1.02C6.62 1.33 3 5.52 3 10.31V17c0 1.66 1.34 3 3 3h1c1.1 0 2-.9 2-2v-4c0-1.1-.9-2-2-2H5v-1.71C5 6.45 7.96 3.11 11.79 3A6.999 6.999 0 0 1 19 10v2h-2c-1.1 0-2 .9-2 2v4c0 1.1.9 2 2 2h2v1h-6c-.55 0-1 .45-1 1s.45 1 1 1h5c1.66 0 3-1.34 3-3V10c0-5.17-4.36-9.32-9.6-8.98z",
    fill: "#9da3a8"
  }));
};
HeadsetMic.displayName = "HeadsetMic";
HeadsetMic.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var Keyboard = function Keyboard(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 5h16c1.1 0 2 .9 2 2v10c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2l.01-10c0-1.1.89-2 1.99-2zm9 3h-2v2h2V8zm-2 3h2v2h-2v-2zm-1-3H8v2h2V8zm-2 3h2v2H8v-2zm-3 2h2v-2H5v2zm2-3H5V8h2v2zm2 7h6c.55 0 1-.45 1-1s-.45-1-1-1H9c-.55 0-1 .45-1 1s.45 1 1 1zm7-4h-2v-2h2v2zm-2-3h2V8h-2v2zm5 3h-2v-2h2v2zm-2-3h2V8h-2v2z",
    fill: "#9da3a8"
  }));
};
Keyboard.displayName = "Keyboard";
Keyboard.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var Gateway = function Gateway(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.46 2.115c.35.04.52.44.35.74l-4.03 6.99c-.2.33-.68.33-.87 0L5.9 4.625c-.13-.22-.07-.5.12-.65 2.14-1.58 4.82-2.23 7.44-1.86zm2.49.71c2.43 1.04 4.37 3.03 5.35 5.5.13.32-.12.67-.47.67h-8.08c-.39 0-.63-.42-.44-.74l3.01-5.21c.13-.22.4-.32.63-.22zm5.42 7.17h-6.2c-.38 0-.63.42-.43.75l4.26 7.39c.17.3.6.35.82.08 1.74-2.18 2.48-5.03 2.05-7.79a.498.498 0 0 0-.5-.43zm-19.24 3.58c-.43-2.77.32-5.6 2.05-7.79.21-.27.64-.22.82.08l4.26 7.38c.2.33-.05.75-.43.75h-6.2c-.25 0-.47-.18-.5-.42zm.57 2.09c.98 2.47 2.92 4.46 5.35 5.5.23.1.5 0 .63-.22l3.01-5.21a.502.502 0 0 0-.43-.75H3.17c-.35.01-.6.36-.47.68zm15.27 4.36a10.139 10.139 0 0 1-7.44 1.86c-.34-.05-.52-.45-.35-.75l4.04-6.99c.2-.33.68-.33.87 0l3.01 5.22c.13.22.07.51-.13.66z",
    fill: "#B8CBD9"
  }));
};
Gateway.displayName = "Gateway";
Gateway.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var ColorLens = function ColorLens(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 3a9 9 0 0 0 0 18c.83 0 1.5-.67 1.5-1.5 0-.39-.15-.74-.39-1.01-.23-.26-.38-.61-.38-.99 0-.83.67-1.5 1.5-1.5H16c2.76 0 5-2.24 5-5 0-4.42-4.03-8-9-8zm-5.5 9c-.83 0-1.5-.67-1.5-1.5S5.67 9 6.5 9 8 9.67 8 10.5 7.33 12 6.5 12zM8 6.5C8 7.33 8.67 8 9.5 8S11 7.33 11 6.5 10.33 5 9.5 5 8 5.67 8 6.5zM14.5 8c-.83 0-1.5-.67-1.5-1.5S13.67 5 14.5 5s1.5.67 1.5 1.5S15.33 8 14.5 8zm1.5 2.5c0 .83.67 1.5 1.5 1.5s1.5-.67 1.5-1.5S18.33 9 17.5 9s-1.5.67-1.5 1.5z",
    fill: "#9da3a8"
  }));
};
ColorLens.displayName = "ColorLens";
ColorLens.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var Image = function Image(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21 5v14c0 1.1-.9 2-2 2H5c-1.1 0-2-.9-2-2V5c0-1.1.9-2 2-2h14c1.1 0 2 .9 2 2zM11 16.51l-2.1-2.53a.493.493 0 0 0-.78.02l-2.49 3.2c-.26.33-.03.81.39.81h11.99a.5.5 0 0 0 .4-.8l-3.51-4.68c-.2-.27-.6-.27-.8-.01L11 16.51z",
    fill: "#9da3a8"
  }));
};
Image.displayName = "Image";
Image.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var Priority = function Priority(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M7 12.25a1.167 1.167 0 1 0 0-2.333 1.167 1.167 0 0 0 0 2.333zM5.833 1.75h2.334v7H5.833v-7z",
    fill: "#fff"
  }));
};
Priority.displayName = "Priority";
Priority.defaultProps = {
  width: "14",
  height: "14",
  viewBox: "0 0 14 14",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var AccountBox = function AccountBox(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 5v14a2 2 0 0 0 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2H5a2 2 0 0 0-2 2zm12 4c0 1.66-1.34 3-3 3s-3-1.34-3-3 1.34-3 3-3 3 1.34 3 3zm-3 4.9c-2 0-6 1.1-6 3.1v1h12v-1c0-2-4-3.1-6-3.1z",
    fill: "#9da3a8"
  }));
};
AccountBox.displayName = "AccountBox";
AccountBox.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var AccountCircle = function AccountCircle(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 3c1.66 0 3 1.34 3 3s-1.34 3-3 3-3-1.34-3-3 1.34-3 3-3zM6 15.98a7.2 7.2 0 0 0 12 0c-.03-1.99-4.01-3.08-6-3.08-2 0-5.97 1.09-6 3.08z",
    fill: "#9da3a8"
  }));
};
AccountCircle.displayName = "AccountCircle";
AccountCircle.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var AddShoppingCart = function AddShoppingCart(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.097 8.5c0 .55-.45 1-1 1s-1-.45-1-1v-2h-2c-.55 0-1-.45-1-1s.45-1 1-1h2v-2c0-.55.45-1 1-1s1 .45 1 1v2h2c.55 0 1 .45 1 1s-.45 1-1 1h-2v2zm-7.99 12c0-1.1.89-2 1.99-2s2 .9 2 2-.9 2-2 2-1.99-.9-1.99-2zm11.99-2c-1.1 0-1.99.9-1.99 2s.89 2 1.99 2 2-.9 2-2-.9-2-2-2zm-1.45-5h-7.45l-1.1 2h11c.55 0 1 .45 1 1s-.45 1-1 1h-11c-1.52 0-2.48-1.63-1.75-2.97l1.35-2.44-3.6-7.59h-1c-.55 0-1-.45-1-1s.45-1 1-1h1.64c.38 0 .74.22.9.57l3.99 8.43h7.02l3.39-6.13c.26-.48.87-.65 1.35-.39.48.27.66.88.39 1.36l-3.38 6.13c-.34.62-1 1.03-1.75 1.03z",
    fill: "#9da3a8"
  }));
};
AddShoppingCart.displayName = "AddShoppingCart";
AddShoppingCart.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var Build = function Build(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M12.473 3.247c-2.01-2.01-5.02-2.42-7.44-1.24l3.63 3.63c.39.39.39 1.02 0 1.41l-1.59 1.59c-.39.4-1.02.4-1.41 0l-3.63-3.63c-1.17 2.43-.76 5.42 1.25 7.43a6.507 6.507 0 0 0 6.89 1.48l7.96 7.96a2.613 2.613 0 0 0 3.71 0 2.613 2.613 0 0 0 0-3.71l-7.92-7.93c.92-2.34.44-5.1-1.45-6.99z",
    fill: "#9da3a8"
  }));
};
Build.displayName = "Build";
Build.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var Cached = function Cached(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 6c-3.31 0-6 2.69-6 6h1.79a.5.5 0 0 1 .36.85l-2.79 2.79c-.2.2-.51.2-.71 0l-2.79-2.79c-.32-.31-.1-.85.35-.85H4c0-4.42 3.58-8 8-8 1.04 0 2.04.2 2.95.57.67.27.85 1.13.34 1.64-.27.27-.68.38-1.04.23C13.56 6.15 12.79 6 12 6zm3.86 5.14l2.79-2.79c.19-.19.51-.19.7.01l2.79 2.79c.32.31.1.85-.35.85H20c0 4.42-3.58 8-8 8-1.04 0-2.04-.2-2.95-.57-.67-.27-.85-1.13-.34-1.64.27-.27.68-.38 1.04-.23.69.29 1.46.44 2.25.44 3.31 0 6-2.69 6-6h-1.79c-.45 0-.67-.54-.35-.86z",
    fill: "#9da3a8"
  }));
};
Cached.displayName = "Cached";
Cached.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var Calendar = function Calendar(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19 3h1c1.1 0 2 .9 2 2v16c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V5c0-1.1.9-2 2-2h1V2c0-.55.45-1 1-1s1 .45 1 1v1h10V2c0-.55.45-1 1-1s1 .45 1 1v1zM5 21h14c.55 0 1-.45 1-1V8H4v12c0 .55.45 1 1 1z",
    fill: "#9da3a8"
  }));
};
Calendar.displayName = "Calendar";
Calendar.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var Cart = function Cart(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.996 3c0 .55.45 1 1 1h1l3.6 7.59-1.35 2.44c-.73 1.34.23 2.97 1.75 2.97h11c.55 0 1-.45 1-1s-.45-1-1-1h-11l1.1-2h7.45c.75 0 1.41-.41 1.75-1.03l3.58-6.49a.996.996 0 0 0-.87-1.48h-14.8l-.67-1.43a.993.993 0 0 0-.9-.57h-1.64c-.55 0-1 .45-1 1zm6 15c-1.1 0-1.99.9-1.99 2s.89 2 1.99 2 2-.9 2-2-.9-2-2-2zm8.01 2c0-1.1.89-2 1.99-2s2 .9 2 2-.9 2-2 2-1.99-.9-1.99-2z",
    fill: "#9da3a8"
  }));
};
Cart.displayName = "Cart";
Cart.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var Check = function Check(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M8.795 15.875l-3.47-3.47a.996.996 0 1 0-1.41 1.41l4.18 4.18c.39.39 1.02.39 1.41 0l10.58-10.58a.996.996 0 1 0-1.41-1.41l-9.88 9.87z",
    fill: "#9da3a8"
  }));
};
Check.displayName = "Check";
Check.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var CheckCircle = function CheckCircle(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 12C2 6.48 6.48 2 12 2s10 4.48 10 10-4.48 10-10 10S2 17.52 2 12zm3.7.7l3.59 3.59c.39.39 1.03.39 1.41 0l7.59-7.59a.996.996 0 1 0-1.41-1.41L10 14.17l-2.89-2.88A.996.996 0 1 0 5.7 12.7z",
    fill: "#9da3a8"
  }));
};
CheckCircle.displayName = "CheckCircle";
CheckCircle.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var CreditCard = function CreditCard(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.964 4h-16c-1.11 0-1.99.89-1.99 2l-.01 12c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V6c0-1.11-.89-2-2-2zm-1 14h-14c-.55 0-1-.45-1-1v-5h16v5c0 .55-.45 1-1 1zm-15-10h16V6h-16v2z",
    fill: "#9da3a8"
  }));
};
CreditCard.displayName = "CreditCard";
CreditCard.defaultProps = {
  width: "25",
  height: "24",
  viewBox: "0 0 25 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var Dashboard = function Dashboard(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 13H4c-.55 0-1-.45-1-1V4c0-.55.45-1 1-1h6c.55 0 1 .45 1 1v8c0 .55-.45 1-1 1zm0 8H4c-.55 0-1-.45-1-1v-4c0-.55.45-1 1-1h6c.55 0 1 .45 1 1v4c0 .55-.45 1-1 1zm4 0h5.999c.55 0 1-.45 1-1v-8c0-.55-.45-1-1-1h-6c-.55 0-1 .45-1 1v8c0 .55.45 1 1 1zM13 8V4c0-.55.45-1 1-1h5.999c.55 0 1 .45 1 1v4c0 .55-.45 1-1 1h-6c-.55 0-1-.45-1-1z",
    fill: "#9da3a8"
  }));
};
Dashboard.displayName = "Dashboard";
Dashboard.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var Delete = function Delete(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.5 4H18c.55 0 1 .45 1 1s-.45 1-1 1H6c-.55 0-1-.45-1-1s.45-1 1-1h2.5l.71-.71c.18-.18.44-.29.7-.29h4.18c.26 0 .52.11.7.29l.71.71zM8 21c-1.1 0-2-.9-2-2V9c0-1.1.9-2 2-2h8c1.1 0 2 .9 2 2v10c0 1.1-.9 2-2 2H8z",
    fill: "#9da3a8"
  }));
};
Delete.displayName = "Delete";
Delete.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var DeleteForever = function DeleteForever(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.79 3.29l.71.71H18c.55 0 1 .45 1 1s-.45 1-1 1H6c-.55 0-1-.45-1-1s.45-1 1-1h2.5l.71-.71c.18-.18.44-.29.7-.29h4.18c.26 0 .52.11.7.29zM6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V9c0-1.1-.9-2-2-2H8c-1.1 0-2 .9-2 2v10zm3.17-7.83a.996.996 0 0 1 1.41 0L12 12.59l1.42-1.42a.996.996 0 1 1 1.41 1.41L13.41 14l1.42 1.42a.996.996 0 1 1-1.41 1.41L12 15.41l-1.42 1.42a.996.996 0 1 1-1.41-1.41L10.59 14l-1.42-1.42a.996.996 0 0 1 0-1.41z",
    fill: "#9da3a8"
  }));
};
DeleteForever.displayName = "DeleteForever";
DeleteForever.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var Description = function Description(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.17 2c.53 0 1.04.21 1.42.59l4.82 4.83c.38.37.59.88.59 1.41V20c0 1.1-.9 2-2 2H5.99C4.89 22 4 21.1 4 20V4c0-1.1.9-2 2-2h7.17zM9 18h6c.55 0 1-.45 1-1s-.45-1-1-1H9c-.55 0-1 .45-1 1s.45 1 1 1zm6-4H9c-.55 0-1-.45-1-1s.45-1 1-1h6c.55 0 1 .45 1 1s-.45 1-1 1zM13 3.5V8c0 .55.45 1 1 1h4.5L13 3.5z",
    fill: "#9da3a8"
  }));
};
Description.displayName = "Description";
Description.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var Download = function Download(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 9.5h1.59c.89 0 1.33 1.08.7 1.71L12.7 15.8a.996.996 0 0 1-1.41 0L6.7 11.21c-.63-.63-.18-1.71.71-1.71H9v-5c0-.55.45-1 1-1h4c.55 0 1 .45 1 1v5zm-9 11c-.55 0-1-.45-1-1s.45-1 1-1h12c.55 0 1 .45 1 1s-.45 1-1 1H6z",
    fill: "#9da3a8"
  }));
};
Download.displayName = "Download";
Download.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var Face = function Face(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zM7.75 13a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 0 1-2.5 0zm6 0a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 0 1-2.5 0zM4 12c0 4.41 3.59 8 8 8s8-3.59 8-8c0-.79-.12-1.55-.33-2.26A9.974 9.974 0 0 1 9.26 5.77c-.98 2.39-2.85 4.32-5.21 5.37-.03.28-.05.57-.05.86z",
    fill: "#9da3a8"
  }));
};
Face.displayName = "Face";
Face.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var HelpOutline = function HelpOutline(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 12C2 6.48 6.48 2 12 2s10 4.48 10 10-4.48 10-10 10S2 17.52 2 12zm2 0c0 4.41 3.59 8 8 8s8-3.59 8-8-3.59-8-8-8-8 3.59-8 8zm9 4v2h-2v-2h2zM8.18 8.83a4.002 4.002 0 0 1 4.43-2.79c1.74.26 3.11 1.73 3.35 3.47.228 1.614-.664 2.392-1.526 3.143-.158.139-.315.276-.464.417-.12.11-.23.22-.33.34-.005.005-.01.012-.015.02l-.015.02a2.758 2.758 0 0 0-.33.48c-.17.3-.28.65-.28 1.07h-2c0-.5.08-.91.2-1.25l.01-.034a.144.144 0 0 1 .01-.036c.005-.015.012-.027.02-.04.008-.013.015-.025.02-.04a3.331 3.331 0 0 1 .265-.525l.015-.025c0-.005.003-.008.005-.01s.005-.005.005-.01c.34-.513.797-.864 1.224-1.193.614-.472 1.167-.897 1.226-1.687.08-.97-.62-1.9-1.57-2.1-1.03-.22-1.98.39-2.3 1.28-.14.38-.47.67-.88.67h-.2a.907.907 0 0 1-.87-1.17z",
    fill: "#9da3a8"
  }));
};
HelpOutline.displayName = "HelpOutline";
HelpOutline.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var Home = function Home(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M9.998 19.328v-5h4v5c0 .55.45 1 1 1h3c.55 0 1-.45 1-1v-7h1.7c.46 0 .68-.57.33-.87l-8.36-7.53c-.38-.34-.96-.34-1.34 0l-8.36 7.53c-.34.3-.13.87.33.87h1.7v7c0 .55.45 1 1 1h3c.55 0 1-.45 1-1z",
    fill: "#9da3a8"
  }));
};
Home.displayName = "Home";
Home.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var Info = function Info(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 15c-.55 0-1-.45-1-1v-4c0-.55.45-1 1-1s1 .45 1 1v4c0 .55-.45 1-1 1zm-1-8h2V7h-2v2z",
    fill: "#9da3a8"
  }));
};
Info.displayName = "Info";
Info.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var Label = function Label(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M17.241 5.84c-.36-.51-.96-.84-1.63-.84l-11 .01c-1.1 0-2 .89-2 1.99v10c0 1.1.9 1.99 2 1.99l11 .01c.67 0 1.27-.33 1.63-.84l3.96-5.58a.99.99 0 0 0 0-1.16l-3.96-5.58z",
    fill: "#9da3a8"
  }));
};
Label.displayName = "Label";
Label.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var Payment = function Payment(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 4H4c-1.11 0-1.99.89-1.99 2L2 18c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V6c0-1.11-.89-2-2-2zm-1 14H5c-.55 0-1-.45-1-1v-5h16v5c0 .55-.45 1-1 1zM4 8h16V7c0-.55-.45-1-1-1H5c-.55 0-1 .45-1 1v1z",
    fill: "#9da3a8"
  }));
};
Payment.displayName = "Payment";
Payment.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var Print = function Print(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 3h10c.55 0 1 .45 1 1v2c0 .55-.45 1-1 1H7c-.55 0-1-.45-1-1V4c0-.55.45-1 1-1zM5 8h14c1.66 0 3 1.34 3 3v4c0 1.1-.9 2-2 2h-2v2c0 1.1-.9 2-2 2H8c-1.1 0-2-.9-2-2v-2H4c-1.1 0-2-.9-2-2v-4c0-1.66 1.34-3 3-3zm4 11h6c.55 0 1-.45 1-1v-4H8v4c0 .55.45 1 1 1zm10-7c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1z",
    fill: "#9da3a8"
  }));
};
Print.displayName = "Print";
Print.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var QuestionAnswer = function QuestionAnswer(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17 4v7c0 1.1-.9 2-2 2H6l-4 4V4c0-1.1.9-2 2-2h11c1.1 0 2 .9 2 2zm2 2h1c1.1 0 2 .9 2 2v14l-4-4H8c-1.1 0-2-.9-2-2v-1h12c.55 0 1-.45 1-1V6z",
    fill: "#9da3a8"
  }));
};
QuestionAnswer.displayName = "QuestionAnswer";
QuestionAnswer.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var SandGlass = function SandGlass(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 2c-1.1 0-2 .9-2 2v3.17c0 .53.21 1.04.59 1.42L10 12l-3.42 3.42c-.37.38-.58.89-.58 1.42V20c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2v-3.16c0-.53-.21-1.04-.58-1.41L14 12l3.41-3.4c.38-.38.59-.89.59-1.42V4c0-1.1-.9-2-2-2H8zm8 14.5V19c0 .55-.45 1-1 1H9c-.55 0-1-.45-1-1v-2.5l4-4 4 4zM8 5v2.5l4 4 4-4V5c0-.55-.45-1-1-1H9c-.55 0-1 .45-1 1z",
    fill: "#9da3a8"
  }));
};
SandGlass.displayName = "SandGlass";
SandGlass.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var SandGlassCircle = function SandGlassCircle(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M12 22c5.522 0 10-4.477 10-10 0-.27-.01-.535-.032-.799C21.562 6.051 17.254 2 12 2 6.477 2 2 6.477 2 12c0 2.561.963 4.898 2.547 6.667A9.972 9.972 0 0 0 12 22zm0-18.106a8.106 8.106 0 1 1-.001 16.212 8.09 8.09 0 0 1-6.042-2.7A8.108 8.108 0 0 1 12 3.893z",
    fill: "#9da3a8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.84 11.334c-.33-3.418-2.798-5.834-6.417-6.154-.16-.014-.38.115-.377.42v6.007a.54.54 0 0 1-.313.514l-5.676 2.187c-.252.093-.313.32-.214.558.277.658.645 1.162 1.116 1.686a6.826 6.826 0 0 0 11.882-5.218z",
    fill: "#9da3a8"
  }));
};
SandGlassCircle.displayName = "SandGlassCircle";
SandGlassCircle.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var Schedule = function Schedule(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm-.28-13h.06c.4 0 .72.32.72.72v4.54l3.87 2.3c.35.2.46.65.25.99-.2.34-.64.44-.98.24l-4.15-2.49a.99.99 0 0 1-.49-.86V7.72c0-.4.32-.72.72-.72z",
    fill: "#9da3a8"
  }));
};
Schedule.displayName = "Schedule";
Schedule.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var Search = function Search(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.187 14.472h.79l4.24 4.26c.41.41.41 1.08 0 1.49-.41.41-1.08.41-1.49 0l-4.25-4.25v-.79l-.27-.28a6.5 6.5 0 0 1-5.34 1.48c-2.78-.47-5-2.79-5.34-5.59a6.505 6.505 0 0 1 7.27-7.27c2.8.34 5.12 2.56 5.59 5.34a6.5 6.5 0 0 1-1.48 5.34l.28.27zm-9.71-4.5c0 2.49 2.01 4.5 4.5 4.5s4.5-2.01 4.5-4.5-2.01-4.5-4.5-4.5-4.5 2.01-4.5 4.5z",
    fill: "#9da3a8"
  }));
};
Search.displayName = "Search";
Search.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var Settings = function Settings(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.502 12c0 .34-.03.66-.07.98l2.11 1.65c.19.15.24.42.12.64l-2 3.46c-.12.22-.38.31-.61.22l-2.49-1c-.52.39-1.08.73-1.69.98l-.38 2.65c-.03.24-.24.42-.49.42h-4c-.25 0-.46-.18-.49-.42l-.38-2.65c-.61-.25-1.17-.58-1.69-.98l-2.49 1c-.22.08-.49 0-.61-.22l-2-3.46a.505.505 0 0 1 .12-.64l2.11-1.65a7.93 7.93 0 0 1-.07-.98c0-.33.03-.66.07-.98l-2.11-1.65a.493.493 0 0 1-.12-.64l2-3.46c.12-.22.38-.31.61-.22l2.49 1c.52-.39 1.08-.73 1.69-.98l.38-2.65c.03-.24.24-.42.49-.42h4c.25 0 .46.18.49.42l.38 2.65c.61.25 1.17.58 1.69.98l2.49-1c.22-.08.49 0 .61.22l2 3.46c.12.22.07.49-.12.64l-2.11 1.65c.04.32.07.64.07.98zm-11 0c0 1.93 1.57 3.5 3.5 3.5s3.5-1.57 3.5-3.5-1.57-3.5-3.5-3.5-3.5 1.57-3.5 3.5z",
    fill: "#9da3a8"
  }));
};
Settings.displayName = "Settings";
Settings.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var SwapHoriz = function SwapHoriz(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.866 5.855l2.78 2.79c.19.19.19.51-.01.7l-2.78 2.79c-.31.32-.85.1-.85-.35v-1.79h-6.01c-.55 0-1-.45-1-1s.45-1 1-1h6.02v-1.79c0-.44.54-.67.85-.35zm-14.51 8.79l2.78-2.79c.31-.32.85-.1.85.35v1.79h6.01c.55 0 1 .45 1 1s-.45 1-1 1h-6.01v1.8c0 .44-.54.67-.85.35l-2.78-2.79a.513.513 0 0 1 0-.71z",
    fill: "#9da3a8"
  }));
};
SwapHoriz.displayName = "SwapHoriz";
SwapHoriz.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var Visibility = function Visibility(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 4.5C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5c-1.73-4.39-6-7.5-11-7.5zM12 17c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5zm-3-5c0-1.66 1.34-3 3-3s3 1.34 3 3-1.34 3-3 3-3-1.34-3-3z",
    fill: "#9da3a8"
  }));
};
Visibility.displayName = "Visibility";
Visibility.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var VisibilityOff = function VisibilityOff(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.71 4.54a.996.996 0 0 1 0-1.41c.39-.39 1.03-.39 1.42 0l16.31 16.33a.996.996 0 1 1-1.41 1.41l-2.72-2.72c-1.34.52-2.79.82-4.31.82-5 0-9.27-3.11-11-7.5.77-1.97 2.06-3.67 3.68-4.96L2.71 4.54zM17 11.47c0-2.76-2.24-5-5-5-.51 0-1 .1-1.47.24L8.36 4.54c1.15-.37 2.37-.57 3.64-.57 5 0 9.27 3.11 11 7.49-.69 1.76-1.79 3.3-3.18 4.53l-3.06-3.06c.14-.46.24-.95.24-1.46zm-5 5c-2.76 0-5-2.24-5-5 0-.77.18-1.5.49-2.14l1.57 1.57c-.03.18-.06.37-.06.57 0 1.66 1.34 3 3 3 .2 0 .38-.03.57-.07l1.57 1.57c-.65.32-1.37.5-2.14.5zm2.97-5.33a2.97 2.97 0 0 0-2.64-2.64l2.64 2.64z",
    fill: "#9da3a8"
  }));
};
VisibilityOff.displayName = "VisibilityOff";
VisibilityOff.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var WatchLater = function WatchLater(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 12C2 6.5 6.5 2 12 2c5.499 0 9.999 4.5 9.999 10s-4.5 10-10 10S2 17.5 2 12zm9.47 1.29l4.08 2.51c.359.22.829.11 1.049-.24.22-.36.1-.83-.26-1.05l-3.84-2.31V7.75c0-.41-.34-.75-.75-.75a.77.77 0 0 0-.76.75v4.69c0 .35.18.67.48.85z",
    fill: "#9da3a8"
  }));
};
WatchLater.displayName = "WatchLater";
WatchLater.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var Work = function Work(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 6.5h4c1.11 0 2 .89 2 2v11c0 1.11-.89 2-2 2H4c-1.11 0-2-.89-2-2l.01-11c0-1.11.88-2 1.99-2h4v-2c0-1.11.89-2 2-2h4c1.11 0 2 .89 2 2v2zm-6 0h4v-2h-4v2z",
    fill: "#9da3a8"
  }));
};
Work.displayName = "Work";
Work.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var WorkOff = function WorkOff(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.634 3.709h-4v1.6l-1.96-1.96c.16-.94.97-1.64 1.96-1.64h4c1.11 0 2 .89 2 2v2h4c1.11 0 2 .89 2 2v9.6l-11.6-11.6h3.6v-2zM3.039 1.956c.264 0 .518.105.705.293l18.33 18.34a.996.996 0 1 1-1.41 1.41l-1.29-1.29H3.634c-1.11 0-2-.89-2-2l.01-11c0-1.11.88-2 1.99-2h.74l-2.04-2.05a.996.996 0 0 1 .705-1.703z",
    fill: "#9da3a8"
  }));
};
WorkOff.displayName = "WorkOff";
WorkOff.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var WorkOutline = function WorkOutline(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22 8.5c0-1.11-.89-2-2-2h-4v-2c0-1.11-.89-2-2-2h-4c-1.11 0-2 .89-2 2v2H4c-1.11 0-1.99.89-1.99 2L2 19.5c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2v-11zm-8-2v-2h-4v2h4zm-10 3v9c0 .55.45 1 1 1h14c.55 0 1-.45 1-1v-9c0-.55-.45-1-1-1H5c-.55 0-1 .45-1 1z",
    fill: "#9da3a8"
  }));
};
WorkOutline.displayName = "WorkOutline";
WorkOutline.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var VerifiedUser = function VerifiedUser(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 1L3 5v6c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V5l-9-4zm-2 16l-4-4 1.41-1.41L10 14.17l6.59-6.59L18 9l-8 8z",
    fill: "red"
  }));
};
VerifiedUser.displayName = "VerifiedUser";
VerifiedUser.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var HistoryToggleOff = function HistoryToggleOff(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M15.1 19.37l1 1.74c-.96.44-2.01.73-3.1.84v-2.02c.74-.09 1.44-.28 2.1-.56zM4.07 13H2.05c.11 1.1.4 2.14.84 3.1l1.74-1c-.28-.66-.47-1.36-.56-2.1zM15.1 4.63l1-1.74c-.96-.44-2-.73-3.1-.84v2.02c.74.09 1.44.28 2.1.56zM19.93 11h2.02c-.11-1.1-.4-2.14-.84-3.1l-1.74 1c.28.66.47 1.36.56 2.1zM8.9 19.37l-1 1.74c.96.44 2.01.73 3.1.84v-2.02c-.74-.09-1.44-.28-2.1-.56zM11 4.07V2.05c-1.1.11-2.14.4-3.1.84l1 1.74c.66-.28 1.36-.47 2.1-.56zm7.36 3.1l1.74-1.01c-.63-.87-1.4-1.64-2.27-2.27l-1.01 1.74c.59.45 1.1.96 1.54 1.54zM4.63 8.9l-1.74-1c-.44.96-.73 2-.84 3.1h2.02c.09-.74.28-1.44.56-2.1zm15.3 4.1c-.09.74-.28 1.44-.56 2.1l1.74 1c.44-.96.73-2.01.84-3.1h-2.02zm-3.1 5.36l1.01 1.74c.87-.63 1.64-1.4 2.27-2.27l-1.74-1.01c-.45.59-.96 1.1-1.54 1.54zM7.17 5.64l-1-1.75c-.88.64-1.64 1.4-2.27 2.28l1.74 1.01a7.7 7.7 0 0 1 1.53-1.54zM5.64 16.83l-1.74 1c.63.87 1.4 1.64 2.27 2.27l1.01-1.74a7.7 7.7 0 0 1-1.54-1.53zM13 7h-2v5.41l4.29 4.29 1.41-1.41-3.7-3.7V7z"
  }));
};
HistoryToggleOff.displayName = "HistoryToggleOff";
HistoryToggleOff.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var History = function History(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.144 12.002c0-5.05 4.17-9.14 9.26-9 4.69.13 8.61 4.05 8.74 8.74.14 5.09-3.95 9.26-9 9.26-2.09 0-4-.71-5.52-1.91-.47-.36-.5-1.07-.08-1.49.36-.36.92-.39 1.32-.08 1.18.93 2.67 1.48 4.28 1.48 3.9 0 7.05-3.19 7-7.1-.05-3.72-3.18-6.85-6.9-6.9-3.92-.05-7.1 3.1-7.1 7h1.79a.5.5 0 0 1 .36.85l-2.79 2.8c-.2.2-.51.2-.71 0l-2.79-2.8c-.32-.31-.1-.85.35-.85h1.79zm8-3.25c0-.41.34-.75.75-.75s.75.34.75.74v3.4l2.88 1.71c.35.21.47.67.26 1.03-.21.35-.67.47-1.03.26l-3.12-1.85c-.3-.18-.49-.51-.49-.86v-3.68z",
    fill: "#696F74"
  }));
};
History.displayName = "History";
History.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var Warning = function Warning(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.53 20.504c1.54 0 2.5-1.67 1.73-3l-7.53-13.01c-.77-1.33-2.69-1.33-3.46 0l-7.53 13.01c-.77 1.33.19 3 1.73 3h15.06zm-7.53-7c-.55 0-1-.45-1-1v-2c0-.55.45-1 1-1s1 .45 1 1v2c0 .55-.45 1-1 1zm-1 2v2h2v-2h-2z",
    fill: "#9da3a8"
  }));
};
Warning.displayName = "Warning";
Warning.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var FiberManualRecord = function FiberManualRecord(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M12 4a8 8 0 1 0 0 16 8 8 0 0 0 0-16z",
    fill: "#9da3a8"
  }));
};
FiberManualRecord.displayName = "FiberManualRecord";
FiberManualRecord.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var Pause = function Pause(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 17c0 1.1-.9 2-2 2s-2-.9-2-2V7c0-1.1.9-2 2-2s2 .9 2 2v10zm4 0V7c0-1.1.9-2 2-2s2 .9 2 2v10c0 1.1-.9 2-2 2s-2-.9-2-2z",
    fill: "#9da3a8"
  }));
};
Pause.displayName = "Pause";
Pause.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var PauseCircle = function PauseCircle(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 14c-.55 0-1-.45-1-1V9c0-.55.45-1 1-1s1 .45 1 1v6c0 .55-.45 1-1 1zm3-1c0 .55.45 1 1 1s1-.45 1-1V9c0-.55-.45-1-1-1s-1 .45-1 1v6z",
    fill: "#fff"
  }));
};
PauseCircle.displayName = "PauseCircle";
PauseCircle.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var SkipNext = function SkipNext(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 17V7c0-.55.45-1 1-1s1 .45 1 1v10c0 .55-.45 1-1 1s-1-.45-1-1zm-2.65-4.18l-5.77 4.07c-.67.46-1.58-.01-1.58-.82V7.93c0-.81.91-1.28 1.58-.82l5.77 4.08c.56.39.56 1.23 0 1.63z",
    fill: "#9da3a8"
  }));
};
SkipNext.displayName = "SkipNext";
SkipNext.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var SkipPrevious = function SkipPrevious(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.995 7c0-.55-.45-1-1-1s-1 .45-1 1v10c0 .55.45 1 1 1s1-.45 1-1V7zm8.43 9.89l-5.77-4.07a1 1 0 0 1 0-1.64l5.77-4.07c.67-.46 1.58.01 1.58.82v8.14c0 .81-.92 1.29-1.58.82z",
    fill: "#9da3a8"
  }));
};
SkipPrevious.displayName = "SkipPrevious";
SkipPrevious.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var Comment = function Comment(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 2c1.1 0 1.99.9 1.99 2L22 22l-4-4H4c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h16zM7 14h10c.55 0 1-.45 1-1s-.45-1-1-1H7c-.55 0-1 .45-1 1s.45 1 1 1zm10-3H7c-.55 0-1-.45-1-1s.45-1 1-1h10c.55 0 1 .45 1 1s-.45 1-1 1zM7 8h10c.55 0 1-.45 1-1s-.45-1-1-1H7c-.55 0-1 .45-1 1s.45 1 1 1z",
    fill: "#9da3a8"
  }));
};
Comment.displayName = "Comment";
Comment.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var Phone = function Phone(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M19.222 15.268l-2.54-.29a1.99 1.99 0 0 0-1.64.57l-1.84 1.84a15.045 15.045 0 0 1-6.59-6.59l1.85-1.85c.43-.43.64-1.03.57-1.64l-.29-2.52a2.001 2.001 0 0 0-1.99-1.77h-1.73c-1.13 0-2.07.94-2 2.07.53 8.54 7.36 15.36 15.89 15.89 1.13.07 2.07-.87 2.07-2v-1.73c.01-1.01-.75-1.86-1.76-1.98z",
    fill: "#9da3a8"
  }));
};
Phone.displayName = "Phone";
Phone.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var AdminPanelSettings = function AdminPanelSettings(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M17 11c.34 0 .67.04 1 .09V6.27L10.5 3 3 6.27v4.91c0 4.54 3.2 8.79 7.5 9.82.55-.13 1.08-.32 1.6-.55-.69-.98-1.1-2.17-1.1-3.45 0-3.31 2.69-6 6-6z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 13c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm0 1.38c.62 0 1.12.51 1.12 1.12 0 .61-.51 1.12-1.12 1.12-.61 0-1.12-.51-1.12-1.12 0-.61.5-1.12 1.12-1.12zm0 5.37c-.93 0-1.74-.46-2.24-1.17.05-.72 1.51-1.08 2.24-1.08.73 0 2.19.36 2.24 1.08-.5.71-1.31 1.17-2.24 1.17z",
    fill: "#000"
  }));
};
AdminPanelSettings.displayName = "AdminPanelSettings";
AdminPanelSettings.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var Add = function Add(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M18 13h-5v5c0 .55-.45 1-1 1s-1-.45-1-1v-5H6c-.55 0-1-.45-1-1s.45-1 1-1h5V6c0-.55.45-1 1-1s1 .45 1 1v5h5c.55 0 1 .45 1 1s-.45 1-1 1z",
    fill: "#9da3a8"
  }));
};
Add.displayName = "Add";
Add.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var AddCircle = function AddCircle(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 12C2 6.48 6.48 2 12 2s10 4.48 10 10-4.48 10-10 10S2 17.52 2 12zm11 1h3c.55 0 1-.45 1-1s-.45-1-1-1h-3V8c0-.55-.45-1-1-1s-1 .45-1 1v3H8c-.55 0-1 .45-1 1s.45 1 1 1h3v3c0 .55.45 1 1 1s1-.45 1-1v-3z",
    fill: "#9da3a8"
  }));
};
AddCircle.displayName = "AddCircle";
AddCircle.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var Block = function Block(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zM4 12c0-4.42 3.58-8 8-8 1.85 0 3.55.63 4.9 1.69L5.69 16.9A7.902 7.902 0 0 1 4 12zm3.1 6.31A7.902 7.902 0 0 0 12 20c4.42 0 8-3.58 8-8 0-1.85-.63-3.55-1.69-4.9L7.1 18.31z",
    fill: "#9da3a8"
  }));
};
Block.displayName = "Block";
Block.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var Close = function Close(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M18.3 5.71a.996.996 0 0 0-1.41 0L12 10.59 7.11 5.7A.996.996 0 1 0 5.7 7.11L10.59 12 5.7 16.89a.996.996 0 1 0 1.41 1.41L12 13.41l4.89 4.89a.996.996 0 1 0 1.41-1.41L13.41 12l4.89-4.89c.38-.38.38-1.02 0-1.4z",
    fill: "#9da3a8"
  }));
};
Close.displayName = "Close";
Close.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var Drafts = function Drafts(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.05 7.644c.57.35.94.98.94 1.7l.01 10c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2v-10c0-.72.38-1.35.95-1.7l8.04-4.71c.62-.37 1.4-.37 2.02 0l8.04 4.71zM3.74 9.184l7.2 4.5c.65.4 1.47.4 2.12 0l7.2-4.5-7.25-4.25c-.62-.37-1.4-.37-2.02 0l-7.25 4.25z",
    fill: "#9da3a8"
  }));
};
Drafts.displayName = "Drafts";
Drafts.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var Clone = function Clone(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.5 1h-11c-1.1 0-2 .9-2 2v13c0 .55.45 1 1 1s1-.45 1-1V4c0-.55.45-1 1-1h10c.55 0 1-.45 1-1s-.45-1-1-1zm4 4h-11c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h11c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm-10 16h9c.55 0 1-.45 1-1V8c0-.55-.45-1-1-1h-9c-.55 0-1 .45-1 1v12c0 .55.45 1 1 1z",
    fill: "#494F54"
  }));
};
Clone.displayName = "Clone";
Clone.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var Create = function Create(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 12C2 6.48 6.48 2 12 2s10 4.48 10 10-4.48 10-10 10S2 17.52 2 12zm11 1h3c.55 0 1-.45 1-1s-.45-1-1-1h-3V8c0-.55-.45-1-1-1s-1 .45-1 1v3H8c-.55 0-1 .45-1 1s.45 1 1 1h3v3c0 .55.45 1 1 1s1-.45 1-1v-3z",
    fill: "#494F54"
  }));
};
Create.displayName = "Create";
Create.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var Edit = function Edit(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.709 5.631c.39.39.39 1.02 0 1.41l-1.83 1.83-3.75-3.75 1.83-1.83a.996.996 0 0 1 1.41 0l2.34 2.34zm-17.71 14.87v-3.04c0-.14.05-.26.15-.36l10.91-10.91 3.75 3.75-10.92 10.91a.47.47 0 0 1-.35.15h-3.04c-.28 0-.5-.22-.5-.5z",
    fill: "#9da3a8"
  }));
};
Edit.displayName = "Edit";
Edit.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var Email = function Email(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2l.01-12c0-1.1.89-2 1.99-2zm8.53 8.67l7.07-4.42a.85.85 0 1 0-.9-1.44L12 11 5.3 6.81a.85.85 0 1 0-.9 1.44l7.07 4.42c.32.2.74.2 1.06 0z",
    fill: "#9da3a8"
  }));
};
Email.displayName = "Email";
Email.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var Flag = function Flag(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M13.9 5.5l-.24-1.2c-.09-.46-.5-.8-.98-.8H5.5c-.55 0-1 .45-1 1v15c0 .55.45 1 1 1s1-.45 1-1v-6h5.6l.24 1.2c.09.47.5.8.98.8h5.18c.55 0 1-.45 1-1v-8c0-.55-.45-1-1-1h-4.6z",
    fill: "#9da3a8"
  }));
};
Flag.displayName = "Flag";
Flag.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var InsertLink = function InsertLink(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.956 4.38c.28-1.47 1.66-2.48 3.16-2.48h2.93c.52 0 .95-.43.95-.95S8.566 0 8.046 0h-2.83C2.606 0 .276 1.91.026 4.51A4.995 4.995 0 0 0 4.996 10h3.05c.52 0 .95-.43.95-.95s-.43-.95-.95-.95h-3.05a3.11 3.11 0 0 1-3.04-3.72zM6.996 6h6c.55 0 1-.45 1-1s-.45-1-1-1h-6c-.55 0-1 .45-1 1s.45 1 1 1zm4.95-6h2.83c2.61 0 4.95 1.91 5.2 4.51a5.008 5.008 0 0 1-4.98 5.49h-3.05c-.52 0-.95-.43-.95-.95s.43-.95.95-.95h3.05a3.11 3.11 0 0 0 3.04-3.72c-.28-1.47-1.66-2.48-3.16-2.48h-2.93c-.52 0-.95-.43-.95-.95s.43-.95.95-.95z",
    fill: "#9da3a8"
  }));
};
InsertLink.displayName = "InsertLink";
InsertLink.defaultProps = {
  width: "20",
  height: "10",
  viewBox: "0 0 20 10",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var OutlinedFlag = function OutlinedFlag(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.78 4.05l.72 1.45h5c.55 0 1 .45 1 1v8c0 .55-.45 1-1 1h-5.39a1 1 0 0 1-.89-.55l-.72-1.45h-5v6c0 .55-.45 1-1 1s-1-.45-1-1v-15c0-.55.45-1 1-1h6.38c.38 0 .73.21.9.55zm.72 9.45h4v-6h-5l-1-2h-5v6h6l1 2z",
    fill: "#9da3a8"
  }));
};
OutlinedFlag.displayName = "OutlinedFlag";
OutlinedFlag.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var Remove = function Remove(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M18 13H6c-.55 0-1-.45-1-1s.45-1 1-1h12c.55 0 1 .45 1 1s-.45 1-1 1z",
    fill: "#9da3a8"
  }));
};
Remove.displayName = "Remove";
Remove.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var RemoveCircleOutline = function RemoveCircleOutline(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zM7 12c0 .55.45 1 1 1h8c.55 0 1-.45 1-1s-.45-1-1-1H8c-.55 0-1 .45-1 1zm-3 0c0 4.41 3.59 8 8 8s8-3.59 8-8-3.59-8-8-8-8 3.59-8 8z",
    fill: "#9da3a8"
  }));
};
RemoveCircleOutline.displayName = "RemoveCircleOutline";
RemoveCircleOutline.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var Save = function Save(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.59 3.59c-.38-.38-.89-.59-1.42-.59H5a2 2 0 0 0-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V7.83c0-.53-.21-1.04-.59-1.41l-2.82-2.83zM12 19c-1.66 0-3-1.34-3-3s1.34-3 3-3 3 1.34 3 3-1.34 3-3 3zM7 9h6c1.1 0 2-.9 2-2s-.9-2-2-2H7c-1.1 0-2 .9-2 2s.9 2 2 2z",
    fill: "#9da3a8"
  }));
};
Save.displayName = "Save";
Save.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var Task = function Task(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.697 11.964c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm1 8l-.86-.86a2.997 2.997 0 0 1 .02-4.26l.84-.82a9.34 9.34 0 0 0-1-.06c-2.67 0-8 1.34-8 4v2h9zm2.76-.22c.39.39 1.03.39 1.42 0l5.14-5.18c.38-.38.38-1 0-1.39l-.01-.01a.996.996 0 0 0-1.41 0l-4.43 4.46-1.37-1.37a.984.984 0 0 0-1.4 0l-.01.01a.99.99 0 0 0 0 1.39l2.07 2.09z",
    fill: "#9da3a8"
  }));
};
Task.displayName = "Task";
Task.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var Undo = function Undo(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M12.466 8c-2.65 0-5.05.99-6.9 2.6l-1.89-1.89c-.63-.63-1.71-.19-1.71.7V15c0 .55.45 1 1 1h5.59c.89 0 1.34-1.08.71-1.71l-1.91-1.91c1.39-1.16 3.16-1.88 5.12-1.88 3.16 0 5.89 1.84 7.19 4.5.27.56.91.84 1.5.64.71-.23 1.07-1.04.75-1.72-1.72-3.5-5.3-5.92-9.45-5.92z",
    fill: "#000"
  }));
};
Undo.displayName = "Undo";
Undo.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var AccessTime = function AccessTime(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm-.28-13h.06c.4 0 .72.32.72.72v4.54l3.87 2.3c.35.2.46.65.25.99-.2.34-.64.44-.98.24l-4.15-2.49a.99.99 0 0 1-.49-.86V7.72c0-.4.32-.72.72-.72z",
    fill: "#9da3a8"
  }));
};
AccessTime.displayName = "AccessTime";
AccessTime.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var Dvr = function Dvr(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 3h18c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2h-5v1c0 .55-.45 1-1 1H9c-.55 0-1-.45-1-1v-1H3c-1.1 0-2-.9-2-2V5c0-1.1.9-2 2-2zm1 14h16c.55 0 1-.45 1-1V6c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1v10c0 .55.45 1 1 1zm14-9H9c-.55 0-1 .45-1 1s.45 1 1 1h9c.55 0 1-.45 1-1s-.45-1-1-1zm-9 4h9c.55 0 1 .45 1 1s-.45 1-1 1H9c-.55 0-1-.45-1-1s.45-1 1-1zM7 8H5v2h2V8zm-2 4h2v2H5v-2z",
    fill: "#9da3a8"
  }));
};
Dvr.displayName = "Dvr";
Dvr.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var Attachment = function Attachment(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M17.252 16H6.672c-2.09 0-3.95-1.53-4.15-3.61A3.998 3.998 0 0 1 6.502 8h12.36c1.31 0 2.5.94 2.63 2.24a2.5 2.5 0 0 1-2.49 2.76h-10.5c-.55 0-1-.45-1-1s.45-1 1-1h8.75c.41 0 .75-.34.75-.75s-.34-.75-.75-.75h-8.61c-1.31 0-2.5.94-2.63 2.24a2.5 2.5 0 0 0 2.49 2.76h10.33c2.09 0 3.95-1.53 4.15-3.61a3.993 3.993 0 0 0-3.98-4.39H6.732c-2.87 0-5.44 2.1-5.71 4.96a5.505 5.505 0 0 0 5.48 6.04h10.75c.41 0 .75-.34.75-.75s-.34-.75-.75-.75z",
    fill: "#9da3a8"
  }));
};
Attachment.displayName = "Attachment";
Attachment.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var Upload = function Upload(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 16.296h-4c-.55 0-1-.45-1-1v-5H7.41c-.89 0-1.33-1.08-.7-1.71l4.59-4.59a.996.996 0 0 1 1.41 0l4.59 4.59c.63.63.18 1.71-.71 1.71H15v5c0 .55-.45 1-1 1zm4 2H6c-.55 0-1 .45-1 1s.45 1 1 1h12c.55 0 1-.45 1-1s-.45-1-1-1z",
    fill: "#9da3a8"
  }));
};
Upload.displayName = "Upload";
Upload.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var Place = function Place(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 9.265c0-3.87 3.13-7 7-7s7 3.13 7 7c0 4.17-4.42 9.92-6.23 12.11-.4.48-1.13.48-1.53 0C9.42 19.185 5 13.435 5 9.265zm4.5 0a2.5 2.5 0 0 0 5 0 2.5 2.5 0 0 0-5 0z",
    fill: "#9da3a8"
  }));
};
Place.displayName = "Place";
Place.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var Shipping = function Shipping(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17 8h2.5c.31 0 .61.15.8.4l2.3 3.07c.26.35.4.77.4 1.2V16c0 .55-.45 1-1 1h-1c0 1.66-1.34 3-3 3s-3-1.34-3-3H9c0 1.66-1.34 3-3 3s-3-1.34-3-3c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2h12c1.1 0 2 .9 2 2v2zM5 17c0 .55.45 1 1 1s1-.45 1-1-.45-1-1-1-1 .45-1 1zm14.5-7.5l1.96 2.5H17V9.5h2.5zM17 17c0 .55.45 1 1 1s1-.45 1-1-.45-1-1-1-1 .45-1 1z",
    fill: "#9da3a8"
  }));
};
Shipping.displayName = "Shipping";
Shipping.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var CreatedMarker = function CreatedMarker(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    opacity: ".15",
    d: "M30.302 17.184c-2.045-2.045-5.807-1.59-8.415 1.018-2.81 2.81-4.348 9.019-4.862 11.456-.112.535.274.92.808.808 2.432-.52 8.641-2.058 11.45-4.868 2.608-2.607 3.063-6.37 1.019-8.414z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 3.209a9.91 9.91 0 0 0-9.917 9.916c0 5.908 6.262 14.054 8.84 17.156.567.68 1.601.68 2.168 0 2.564-3.102 8.826-11.248 8.826-17.156A9.91 9.91 0 0 0 17 3.21z",
    fill: "#83898E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.583 13.125A9.41 9.41 0 0 1 17 3.71a9.41 9.41 0 0 1 9.417 9.416c0 2.81-1.502 6.222-3.381 9.374-1.867 3.131-4.055 5.92-5.33 7.463a.907.907 0 0 1-1.398 0c-1.281-1.542-3.473-4.332-5.342-7.463-1.881-3.152-3.383-6.565-3.383-9.374z",
    stroke: "#000",
    strokeOpacity: ".3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.947 12.56l-1.24-1.413.173-1.874a.67.67 0 0 0-.513-.713l-1.84-.42-.96-1.62a.665.665 0 0 0-.833-.273L17 7l-1.726-.74a.662.662 0 0 0-.834.273l-.966 1.614-1.834.413a.664.664 0 0 0-.52.713l.174 1.867-1.24 1.42a.67.67 0 0 0 0 .88l1.24 1.413-.174 1.88a.67.67 0 0 0 .514.714l1.84.42.96 1.613a.67.67 0 0 0 .84.273L17 19l1.727.74a.662.662 0 0 0 .833-.273l.96-1.62 1.84-.42a.663.663 0 0 0 .514-.714L22.7 14.84l1.24-1.413a.644.644 0 0 0 .007-.867zM17.667 15v1.333h-1.333V15h1.333zm-1.333-2c0 .367.3.667.666.667.367 0 .667-.3.667-.667v-2.667c0-.366-.3-.666-.667-.666-.366 0-.666.3-.666.666V13z",
    fill: "#fff"
  }));
};
CreatedMarker.displayName = "CreatedMarker";
CreatedMarker.defaultProps = {
  width: "34",
  height: "34",
  viewBox: "0 0 34 34",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var AssignedMarker = function AssignedMarker(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    opacity: ".15",
    d: "M30.302 17.184c-2.045-2.045-5.807-1.59-8.415 1.018-2.81 2.81-4.348 9.019-4.862 11.456-.112.535.273.92.808.808 2.432-.52 8.641-2.058 11.45-4.868 2.608-2.607 3.063-6.37 1.019-8.414z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 3.209a9.91 9.91 0 0 0-9.917 9.916c0 5.908 6.262 14.054 8.84 17.156.567.68 1.601.68 2.168 0 2.564-3.102 8.826-11.248 8.826-17.156A9.91 9.91 0 0 0 17 3.21z",
    fill: "#42A8D5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.583 13.125A9.41 9.41 0 0 1 17 3.71a9.41 9.41 0 0 1 9.417 9.416c0 2.81-1.502 6.222-3.381 9.374-1.867 3.131-4.055 5.92-5.33 7.463a.907.907 0 0 1-1.398 0c-1.282-1.543-3.473-4.332-5.342-7.463-1.881-3.152-3.383-6.565-3.383-9.374z",
    stroke: "#000",
    strokeOpacity: ".3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.132 13.976a2.666 2.666 0 1 0 0-5.334 2.666 2.666 0 1 0 0 5.334zm.666 5.333l-.573-.573a1.998 1.998 0 0 1 .013-2.84l.56-.547a6.244 6.244 0 0 0-.666-.04c-1.78 0-5.334.894-5.334 2.667v1.333h6zm.46-1.54l1.38 1.394c.26.26.687.26.947 0l3.427-3.454a.66.66 0 0 0 0-.926l-.007-.007a.664.664 0 0 0-.94 0l-2.953 2.973-.914-.913a.656.656 0 0 0-.933 0l-.007.007a.66.66 0 0 0 0 .926z",
    fill: "#fff"
  }));
};
AssignedMarker.displayName = "AssignedMarker";
AssignedMarker.defaultProps = {
  width: "34",
  height: "34",
  viewBox: "0 0 34 34",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var InprogressMarker = function InprogressMarker(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    opacity: ".15",
    d: "M30.302 17.184c-2.045-2.045-5.807-1.59-8.415 1.018-2.81 2.81-4.348 9.019-4.862 11.456-.112.535.273.92.808.808 2.432-.52 8.641-2.058 11.45-4.868 2.608-2.607 3.063-6.37 1.019-8.414z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 3.209a9.91 9.91 0 0 0-9.917 9.916c0 5.908 6.262 14.054 8.84 17.156.567.68 1.601.68 2.168 0 2.564-3.102 8.826-11.248 8.826-17.156A9.91 9.91 0 0 0 17 3.21z",
    fill: "#F19C2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.583 13.125A9.41 9.41 0 0 1 17 3.71a9.41 9.41 0 0 1 9.417 9.416c0 2.81-1.502 6.222-3.381 9.374-1.867 3.131-4.055 5.92-5.33 7.463a.907.907 0 0 1-1.398 0c-1.281-1.542-3.473-4.332-5.342-7.463-1.881-3.152-3.383-6.565-3.383-9.374z",
    stroke: "#000",
    strokeOpacity: ".3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.333 7.333c-.733 0-1.333.6-1.333 1.334v2.113c0 .353.14.693.393.947L15.667 14l-2.28 2.28a1.36 1.36 0 0 0-.387.947v2.106c0 .734.6 1.334 1.333 1.334h5.334c.733 0 1.333-.6 1.333-1.334v-2.106c0-.354-.14-.694-.387-.94L18.333 14l2.274-2.267c.253-.253.393-.593.393-.946v-2.12c0-.734-.6-1.334-1.333-1.334h-5.334zM19.667 17v1.667c0 .366-.3.666-.667.666h-4a.669.669 0 0 1-.667-.666V17L17 14.333 19.667 17zm-5.334-6L17 13.667 19.667 11V9.333c0-.366-.3-.666-.667-.666h-4c-.367 0-.667.3-.667.666V11z",
    fill: "#fff"
  }));
};
InprogressMarker.displayName = "InprogressMarker";
InprogressMarker.defaultProps = {
  width: "34",
  height: "34",
  viewBox: "0 0 34 34",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var PausedMarker = function PausedMarker(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    opacity: ".15",
    d: "M30.302 17.184c-2.045-2.045-5.807-1.59-8.415 1.018-2.81 2.81-4.348 9.019-4.862 11.456-.112.535.274.92.808.808 2.432-.52 8.641-2.058 11.45-4.868 2.608-2.607 3.063-6.37 1.019-8.414z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 3.209a9.91 9.91 0 0 0-9.917 9.916c0 5.908 6.262 14.054 8.84 17.156.567.68 1.601.68 2.168 0 2.564-3.102 8.826-11.248 8.826-17.156A9.91 9.91 0 0 0 17 3.21z",
    fill: "#D75453"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.583 13.125A9.41 9.41 0 0 1 17 3.71a9.41 9.41 0 0 1 9.417 9.416c0 2.81-1.502 6.222-3.381 9.374-1.867 3.131-4.055 5.92-5.33 7.463a.907.907 0 0 1-1.398 0c-1.281-1.542-3.473-4.332-5.342-7.463-1.881-3.152-3.383-6.565-3.383-9.374z",
    stroke: "#000",
    strokeOpacity: ".3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.667 17.333c0 .734-.6 1.334-1.334 1.334-.733 0-1.333-.6-1.333-1.334v-6.666c0-.734.6-1.334 1.333-1.334.734 0 1.334.6 1.334 1.334v6.666zm2.666 0v-6.666c0-.734.6-1.334 1.334-1.334.733 0 1.333.6 1.333 1.334v6.666c0 .734-.6 1.334-1.333 1.334-.734 0-1.334-.6-1.334-1.334z",
    fill: "#fff"
  }));
};
PausedMarker.displayName = "PausedMarker";
PausedMarker.defaultProps = {
  width: "34",
  height: "34",
  viewBox: "0 0 34 34",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var CompletedMarker = function CompletedMarker(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    opacity: ".15",
    d: "M30.302 17.184c-2.045-2.045-5.807-1.59-8.415 1.018-2.81 2.81-4.348 9.019-4.862 11.456-.112.535.274.92.808.808 2.432-.52 8.641-2.058 11.45-4.868 2.608-2.607 3.063-6.37 1.019-8.414z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 3.209a9.91 9.91 0 0 0-9.917 9.916c0 5.908 6.262 14.054 8.84 17.156.567.68 1.601.68 2.168 0 2.564-3.102 8.826-11.248 8.826-17.156A9.91 9.91 0 0 0 17 3.21z",
    fill: "#47C2B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.583 13.125A9.41 9.41 0 0 1 17 3.71a9.41 9.41 0 0 1 9.417 9.416c0 2.81-1.502 6.222-3.381 9.374-1.867 3.131-4.055 5.92-5.33 7.463a.907.907 0 0 1-1.398 0c-1.281-1.542-3.473-4.332-5.342-7.463-1.881-3.152-3.383-6.565-3.383-9.374z",
    stroke: "#000",
    strokeOpacity: ".3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.863 16.583L12.55 14.27a.664.664 0 1 0-.94.94l2.787 2.787c.26.26.68.26.94 0l7.053-7.054a.664.664 0 1 0-.94-.94l-6.587 6.58z",
    fill: "#fff"
  }));
};
CompletedMarker.displayName = "CompletedMarker";
CompletedMarker.defaultProps = {
  width: "34",
  height: "34",
  viewBox: "0 0 34 34",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var ArrowBack = function ArrowBack(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M18.791 11.005H7.621l4.88-4.88c.39-.39.39-1.03 0-1.42a.996.996 0 0 0-1.41 0l-6.59 6.59a.996.996 0 0 0 0 1.41l6.59 6.59a.996.996 0 1 0 1.41-1.41l-4.88-4.88h11.17c.55 0 1-.45 1-1s-.45-1-1-1z",
    fill: "#9da3a8"
  }));
};
ArrowBack.displayName = "ArrowBack";
ArrowBack.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var ArrowDropDown = function ArrowDropDown(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M8.706 11.414l2.59 2.59c.39.39 1.02.39 1.41 0l2.59-2.59c.63-.63.18-1.71-.71-1.71h-5.18c-.89 0-1.33 1.08-.7 1.71z",
    fill: "#9da3a8"
  }));
};
ArrowDropDown.displayName = "ArrowDropDown";
ArrowDropDown.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var ArrowDropUp = function ArrowDropUp(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M8.706 12.586l2.59-2.59a.996.996 0 0 1 1.41 0l2.59 2.59c.63.63.18 1.71-.71 1.71h-5.18c-.89 0-1.33-1.08-.7-1.71z",
    fill: "#9da3a8"
  }));
};
ArrowDropUp.displayName = "ArrowDropUp";
ArrowDropUp.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var ArrowForward = function ArrowForward(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M5.209 13h11.17l-4.88 4.88c-.39.39-.39 1.03 0 1.42.39.39 1.02.39 1.41 0l6.59-6.59a.996.996 0 0 0 0-1.41l-6.58-6.6a.996.996 0 0 0-1.41 0 .996.996 0 0 0 0 1.41l4.87 4.89H5.209c-.55 0-1 .45-1 1s.45 1 1 1z",
    fill: "#9da3a8"
  }));
};
ArrowForward.displayName = "ArrowForward";
ArrowForward.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var ArrowLeft = function ArrowLeft(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M12.586 8.706l-2.59 2.59a.996.996 0 0 0 0 1.41l2.59 2.59c.63.63 1.71.18 1.71-.71v-5.18c0-.89-1.08-1.33-1.71-.7z",
    fill: "#9da3a8"
  }));
};
ArrowLeft.displayName = "ArrowLeft";
ArrowLeft.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var Cancel = function Cancel(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 12C2 6.47 6.47 2 12 2s10 4.47 10 10-4.47 10-10 10S2 17.53 2 12zm12.89 4.3c.39.39 1.02.39 1.41 0 .38-.39.38-1.03 0-1.41L13.41 12l2.89-2.89a.996.996 0 1 0-1.41-1.41L12 10.59 9.11 7.7A.996.996 0 1 0 7.7 9.11L10.59 12 7.7 14.89a.996.996 0 1 0 1.41 1.41L12 13.41l2.89 2.89z",
    fill: "#9da3a8"
  }));
};
Cancel.displayName = "Cancel";
Cancel.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var ExpandMore = function ExpandMore(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M15.875 9l-3.88 3.88L8.115 9a.996.996 0 1 0-1.41 1.41l4.59 4.59c.39.39 1.02.39 1.41 0l4.59-4.59a.996.996 0 0 0 0-1.41c-.39-.38-1.03-.39-1.42 0z",
    fill: "#9da3a8"
  }));
};
ExpandMore.displayName = "ExpandMore";
ExpandMore.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var KeyboardArrowLeft = function KeyboardArrowLeft(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M15 15.875l-3.88-3.88L15 8.115a.996.996 0 1 0-1.41-1.41L9 11.295a.996.996 0 0 0 0 1.41l4.59 4.59c.39.39 1.02.39 1.41 0 .38-.39.39-1.03 0-1.42z",
    fill: "#9da3a8"
  }));
};
KeyboardArrowLeft.displayName = "KeyboardArrowLeft";
KeyboardArrowLeft.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var KeyboardArrowRight = function KeyboardArrowRight(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M9 15.875l3.88-3.88L9 8.115a.996.996 0 1 1 1.41-1.41l4.59 4.59c.39.39.39 1.02 0 1.41l-4.59 4.59a.996.996 0 0 1-1.41 0c-.38-.39-.39-1.03 0-1.42z",
    fill: "#9da3a8"
  }));
};
KeyboardArrowRight.displayName = "KeyboardArrowRight";
KeyboardArrowRight.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var CheckBox = function CheckBox(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 3h14c1.1 0 2 .9 2 2v14c0 1.1-.9 2-2 2H5c-1.1 0-2-.9-2-2V5c0-1.1.9-2 2-2zm4.3 13.29c.39.39 1.02.39 1.41 0l7.58-7.59a.996.996 0 1 0-1.41-1.41L10 14.17l-2.88-2.88a.996.996 0 1 0-1.41 1.41l3.59 3.59z",
    fill: "#9da3a8"
  }));
};
CheckBox.displayName = "CheckBox";
CheckBox.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var CheckBoxOutlineBlank = function CheckBoxOutlineBlank(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 3h14c1.1 0 2 .9 2 2v14c0 1.1-.9 2-2 2H5c-1.1 0-2-.9-2-2V5c0-1.1.9-2 2-2zm1 16h12c.55 0 1-.45 1-1V6c0-.55-.45-1-1-1H6c-.55 0-1 .45-1 1v12c0 .55.45 1 1 1z",
    fill: "#9da3a8"
  }));
};
CheckBoxOutlineBlank.displayName = "CheckBoxOutlineBlank";
CheckBoxOutlineBlank.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var IndeterminateCheckBox = function IndeterminateCheckBox(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 3h14c1.1 0 2 .9 2 2v14c0 1.1-.9 2-2 2H5c-1.1 0-2-.9-2-2V5c0-1.1.9-2 2-2zm3 10h8c.55 0 1-.45 1-1s-.45-1-1-1H8c-.55 0-1 .45-1 1s.45 1 1 1z",
    fill: "#9da3a8"
  }));
};
IndeterminateCheckBox.displayName = "IndeterminateCheckBox";
IndeterminateCheckBox.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var RadioButtonChecked = function RadioButtonChecked(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm-5-8a5 5 0 1 1 10 0 5 5 0 0 1-10 0z",
    fill: "#9da3a8"
  }));
};
RadioButtonChecked.displayName = "RadioButtonChecked";
RadioButtonChecked.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var RadioButtonUnchecked = function RadioButtonUnchecked(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 12C2 6.48 6.48 2 12 2s10 4.48 10 10-4.48 10-10 10S2 17.52 2 12zm2 0c0 4.42 3.58 8 8 8s8-3.58 8-8-3.58-8-8-8-8 3.58-8 8z",
    fill: "#9da3a8"
  }));
};
RadioButtonUnchecked.displayName = "RadioButtonUnchecked";
RadioButtonUnchecked.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var Star = function Star(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M12 17.52l4.15 2.51c.76.46 1.69-.22 1.49-1.08l-1.1-4.72 3.67-3.18c.67-.58.31-1.68-.57-1.75l-4.83-.41-1.89-4.46c-.34-.81-1.5-.81-1.84 0L9.19 8.88l-4.83.41c-.88.07-1.24 1.17-.57 1.75l3.67 3.18-1.1 4.72c-.2.86.73 1.54 1.49 1.08l4.15-2.5z",
    fill: "#9da3a8"
  }));
};
Star.displayName = "Star";
Star.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var StarBorder = function StarBorder(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.809 8.875l4.84.42c.88.07 1.23 1.17.56 1.75l-3.67 3.18 1.1 4.73c.2.86-.73 1.54-1.49 1.08l-4.15-2.51-4.15 2.5c-.76.46-1.69-.22-1.49-1.08l1.1-4.72-3.67-3.18c-.67-.58-.31-1.68.57-1.75l4.83-.41 1.89-4.46c.34-.81 1.5-.81 1.84 0l1.89 4.45zm-6.57 9.05l3.76-2.27 3.77 2.28-1-4.28 3.32-2.88-4.38-.38-1.71-4.04-1.7 4.03-4.38.38 3.32 2.88-1 4.28z",
    fill: "#9da3a8"
  }));
};
StarBorder.displayName = "StarBorder";
StarBorder.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var ArrowBackIos = function ArrowBackIos(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M17.002 2.985a1.25 1.25 0 0 0-1.77 0l-8.31 8.31a.996.996 0 0 0 0 1.41l8.31 8.31c.49.49 1.28.49 1.77 0s.49-1.28 0-1.77l-7.24-7.25 7.25-7.25c.48-.48.48-1.28-.01-1.76z",
    fill: "#9da3a8"
  }));
};
ArrowBackIos.displayName = "ArrowBackIos";
ArrowBackIos.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var ArrowDownward = function ArrowDownward(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M11.005 5.209v11.17l-4.88-4.88c-.39-.39-1.03-.39-1.42 0a.996.996 0 0 0 0 1.41l6.59 6.59c.39.39 1.02.39 1.41 0l6.59-6.59a.996.996 0 1 0-1.41-1.41l-4.88 4.88V5.209c0-.55-.45-1-1-1s-1 .45-1 1z",
    fill: "#9da3a8"
  }));
};
ArrowDownward.displayName = "ArrowDownward";
ArrowDownward.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var ArrowForwardIos = function ArrowForwardIos(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M6.998 21.015c.49.49 1.28.49 1.77 0l8.31-8.31a.996.996 0 0 0 0-1.41l-8.31-8.31a1.25 1.25 0 0 0-1.77 0 1.25 1.25 0 0 0 0 1.77l7.24 7.25-7.25 7.25c-.48.48-.48 1.28.01 1.76z",
    fill: "#9da3a8"
  }));
};
ArrowForwardIos.displayName = "ArrowForwardIos";
ArrowForwardIos.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var ArrowUpward = function ArrowUpward(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M13 18.791V7.621l4.88 4.88c.39.39 1.03.39 1.42 0a.996.996 0 0 0 0-1.41l-6.59-6.59a.996.996 0 0 0-1.41 0l-6.6 6.58a.996.996 0 1 0 1.41 1.41L11 7.621v11.17c0 .55.45 1 1 1s1-.45 1-1z",
    fill: "#9da3a8"
  }));
};
ArrowUpward.displayName = "ArrowUpward";
ArrowUpward.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var ExpandLess = function ExpandLess(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M11.295 9l-4.59 4.59A.996.996 0 1 0 8.115 15l3.89-3.88 3.88 3.88a.996.996 0 1 0 1.41-1.41L12.705 9a.996.996 0 0 0-1.41 0z",
    fill: "#9da3a8"
  }));
};
ExpandLess.displayName = "ExpandLess";
ExpandLess.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var Fullscreen = function Fullscreen(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 9c0 .55-.45 1-1 1s-1-.45-1-1V6c0-.55.45-1 1-1h3c.55 0 1 .45 1 1s-.45 1-1 1H7v2zm-2 6c0-.55.45-1 1-1s1 .45 1 1v2h2c.55 0 1 .45 1 1s-.45 1-1 1H6c-.55 0-1-.45-1-1v-3zm12 2h-2c-.55 0-1 .45-1 1s.45 1 1 1h3c.55 0 1-.45 1-1v-3c0-.55-.45-1-1-1s-1 .45-1 1v2zM15 7c-.55 0-1-.45-1-1s.45-1 1-1h3c.55 0 1 .45 1 1v3c0 .55-.45 1-1 1s-1-.45-1-1V7h-2z",
    fill: "#9da3a8"
  }));
};
Fullscreen.displayName = "Fullscreen";
Fullscreen.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var Menu = function Menu(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 8c-.55 0-1-.45-1-1s.45-1 1-1h16c.55 0 1 .45 1 1s-.45 1-1 1H4zm0 5h16c.55 0 1-.45 1-1s-.45-1-1-1H4c-.55 0-1 .45-1 1s.45 1 1 1zm0 5h16c.55 0 1-.45 1-1s-.45-1-1-1H4c-.55 0-1 .45-1 1s.45 1 1 1z",
    fill: "#9da3a8"
  }));
};
Menu.displayName = "Menu";
Menu.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var MoreHoriz = function MoreHoriz(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 10c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm12 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm-8 2c0-1.1.9-2 2-2s2 .9 2 2-.9 2-2 2-2-.9-2-2z",
    fill: "#9da3a8"
  }));
};
MoreHoriz.displayName = "MoreHoriz";
MoreHoriz.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var MoreVert = function MoreVert(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 8c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm-2 8c0-1.1.9-2 2-2s2 .9 2 2-.9 2-2 2-2-.9-2-2z",
    fill: "#9da3a8"
  }));
};
MoreVert.displayName = "MoreVert";
MoreVert.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var Amex = function Amex(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M16.895 14.925l-2.34-2.49v1.136h-2.886v.787h2.817v1.14h-2.817v.773h2.886v1.151l2.34-2.497zM21 17.373v-1.03l-1.327-1.431L21 13.494v-1.042l-2.311 2.473L21 17.373z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 11.712v-.006l-.678.006-.655.006V8.263l-1.259 3.443h-1.217l-1.285-3.454v3.454h-2.902l-.001-.001-.42-1.005H10.3l-.42 1.002-.002.005H8.347l2.233-5.03h1.769l2.203 4.982V6.677l2.153.008 1.108 3.09 1.115-3.098H21v-.7h-2.609L17.8 7.63l-.589-1.654h-3.416v2.207l-.972-2.207h-2.767l-2.842 6.45h2.307v5.725l7.117.015 1.118-1.247 1.126 1.242H21v-.717h-1.767l-1.468-1.611-1.454 1.61H10.287v-5.017h6.088l1.429 1.58 1.433-1.58H21v-.715z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.111 9.571l-.669-1.601-.67 1.601h1.339z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 16.343v-2.849l-1.327 1.418L21 16.343z",
    fill: "#016FD0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 3v18h18v-2.838h-2.118l-1.126-1.242-1.118 1.247-7.117-.015v-5.725H7.214l2.842-6.45h2.767l.972 2.207V5.977h3.416l.589 1.654.591-1.653H21v.7h-2.072l-1.115 3.099-1.108-3.091-2.153-.007v4.982l-2.203-4.983H10.58l-2.233 5.029h1.532l.002-.004.419-1.003h2.283l.42 1.005.001.001h1.57v-.001h1.334V8.252l1.285 3.454h1.217l1.259-3.442V11.718l.656-.006.678-.006v.007V3H3zm7.772 6.571l.67-1.601.669 1.601h-1.339z",
    fill: "#016FD0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 12.427h-1.763l-1.433 1.58-1.429-1.58h-6.087v5.018H16.312l1.453-1.611 1.468 1.611H21v-.071l-2.311-2.448L21 12.452v-.04.015zm-6.445 4.995v-1.151h-2.886v-.773h2.817v-1.14h-2.817v-.787h2.886v-1.136l2.34 2.491-2.34 2.496z",
    fill: "#016FD0"
  }));
};
Amex.displayName = "Amex";
Amex.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var Cash = function Cash(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M21.091 14.818H2.909c-.5 0-.909-.409-.909-.909v-10c0-.5.409-.909.909-.909h18.182c.5 0 .909.409.909.909v10c0 .5-.409.91-.909.91z",
    fill: "#0E9347"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.818 11.182c-1.045 0-2 .5-2.545 1.318-.455-.227-.955-.409-1.545-.409-1.591 0-2.91 1.182-3.137 2.727h9.5c.455 0 .819-.318.91-.772-.183-1.591-1.546-2.864-3.183-2.864z",
    fill: "#0D8944"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.273 13.909H4.727c0-1-.818-1.818-1.818-1.818V5.727c1 0 1.818-.818 1.818-1.818h14.546c0 1 .818 1.818 1.818 1.818v6.364c-1 0-1.818.818-1.818 1.818z",
    fill: "#3BB54A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.818 11.181c-1.045 0-2 .5-2.545 1.319-.455-.227-.955-.41-1.545-.41a3.123 3.123 0 0 0-2.864 1.82h7.41c0-1 .772-1.773 1.772-1.82-.591-.545-1.364-.909-2.228-.909z",
    fill: "#0E9347"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 13c2.008 0 3.636-1.832 3.636-4.091 0-2.26-1.628-4.091-3.636-4.091s-3.636 1.831-3.636 4.09C8.364 11.169 9.992 13 12 13zM6.545 9.818a.909.909 0 1 0 0-1.818.909.909 0 0 0 0 1.818zM17.455 9.818a.909.909 0 1 0 0-1.818.909.909 0 0 0 0 1.818z",
    fill: "#0E9347"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.455 8.455h-.91c-.272 0-.454-.182-.454-.455s.182-.455.455-.455h1.363c.273 0 .455-.181.455-.454s-.182-.455-.455-.455h-.454c0-.273-.182-.455-.455-.455s-.455.182-.455.455A1.34 1.34 0 0 0 10.182 8a1.34 1.34 0 0 0 1.363 1.363h.91c.272 0 .454.182.454.455s-.182.455-.455.455h-1.363c-.273 0-.455.181-.455.454s.182.455.455.455h.454c0 .273.182.455.455.455s.455-.182.455-.455a1.34 1.34 0 0 0 1.363-1.364 1.34 1.34 0 0 0-1.363-1.363z",
    fill: "#89C763"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.818 18.454a3.182 3.182 0 1 0 0-6.363 3.182 3.182 0 0 0 0 6.363z",
    fill: "#FFCA5D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.909 17.545a3.182 3.182 0 1 0 0-6.363 3.182 3.182 0 0 0 0 6.363z",
    fill: "#F6B545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.909 11.182a3.162 3.162 0 0 0-3.182 3.181 3.162 3.162 0 0 0 3.182 3.182 3.162 3.162 0 0 0 3.182-3.182 3.162 3.162 0 0 0-3.182-3.181zm0 5.454a2.25 2.25 0 0 1-2.273-2.272c0-1.273 1-2.273 2.273-2.273 1.273 0 2.273 1 2.273 2.273 0 1.272-1 2.272-2.273 2.272z",
    fill: "#FFCB5B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.909 17.5c1.773.045 3.182-1.409 3.182-3.136h-.046c-.227 0-.409.181-.454.409a2.748 2.748 0 0 1-.864 1.636c-.364.364-.864.591-1.41.682a.408.408 0 0 0-.408.409z",
    fill: "#F6B545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.909 11.227c-1.773-.045-3.182 1.41-3.182 3.137h.046c.227 0 .409-.182.454-.41a2.747 2.747 0 0 1 .864-1.636c.364-.363.864-.59 1.409-.681a.408.408 0 0 0 .409-.41z",
    fill: "#FFE27A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.955 14.682c0-1.273 1-2.273 2.272-2.273.546 0 1.046.182 1.455.545-.455-.545-1.045-.863-1.773-.863a2.25 2.25 0 0 0-2.272 2.272c0 .728.318 1.319.818 1.728-.319-.364-.5-.864-.5-1.41z",
    fill: "#F19920"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.273 15.773c-.046 0-.091 0-.137-.046a.22.22 0 0 1 0-.318c.273-.273.41-.682.41-1.045 0-.137.09-.228.227-.228.136 0 .227.091.227.228 0 .5-.182 1-.5 1.363-.091.046-.182.046-.227.046z",
    fill: "#FFCB5B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.909 15.727c-.273 0-.455-.181-.455-.454v-1.819c0-.272.182-.454.455-.454s.455.181.455.454v1.819c0 .272-.182.454-.455.454z",
    fill: "#F19920"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.591 17.045c-.318-1.136-1.136-2.045-2.182-2.454-.181-1.046-.863-1.955-1.727-2.5-.545.59-.909 1.363-.909 2.227a3.162 3.162 0 0 0 3.182 3.182c.59.045 1.136-.136 1.636-.455z",
    fill: "#F19920"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.455 16.091c-.319-.409-.546-.909-.546-1.455A2.2 2.2 0 0 1 16.637 13a1.99 1.99 0 0 0-.273-.318c-.455.409-.727 1-.727 1.681 0 .728.318 1.319.818 1.728zM17.455 14.636v.637c0 .272.181.454.454.454s.455-.181.455-.454v-.091a3.734 3.734 0 0 0-.91-.546z",
    fill: "#E78825"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.591 17.045c-.091-.318-.182-.59-.364-.863a2.201 2.201 0 0 1-1.318.454 2.25 2.25 0 0 1-2.273-2.272c0-.682.273-1.273.728-1.682a2.773 2.773 0 0 0-.728-.545c-.545.59-.909 1.363-.909 2.227a3.162 3.162 0 0 0 3.182 3.182 3.05 3.05 0 0 0 1.682-.5z",
    fill: "#F6B545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.455 16.636c-.319.228-.728.364-1.137.455-.227.045-.409.227-.409.455.637 0 1.182-.182 1.682-.5a245.07 245.07 0 0 1-.136-.41z",
    fill: "#F19920"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.636 12.136c-.545.591-.909 1.364-.909 2.228h.046c.227 0 .409-.182.454-.41a2.829 2.829 0 0 1 .819-1.59c-.137-.046-.273-.137-.41-.228z",
    fill: "#FFCB5B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.818 18.454a3.182 3.182 0 1 0 0-6.363 3.182 3.182 0 0 0 0 6.363z",
    fill: "#F6B545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.364 17.545c0 .319.045.591.136.91h.318A3.162 3.162 0 0 0 17 15.272c0-.319-.045-.591-.136-.91h-.319a3.162 3.162 0 0 0-3.181 3.182z",
    fill: "#F19920"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.818 12.091a3.162 3.162 0 0 0-3.181 3.182 3.162 3.162 0 0 0 3.181 3.181A3.162 3.162 0 0 0 17 15.273a3.162 3.162 0 0 0-3.182-3.182zm0 5.454a2.25 2.25 0 0 1-2.272-2.272c0-1.273 1-2.273 2.272-2.273 1.273 0 2.273 1 2.273 2.273 0 1.272-1 2.272-2.273 2.272z",
    fill: "#FFCB5B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.818 18.409C15.591 18.454 17 17 17 15.273h-.045c-.228 0-.41.181-.455.409a2.748 2.748 0 0 1-.864 1.636c-.363.364-.863.591-1.409.682a.408.408 0 0 0-.409.409z",
    fill: "#F6B545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.818 12.136c-1.772-.045-3.181 1.41-3.181 3.137h.045c.227 0 .409-.182.455-.41A2.748 2.748 0 0 1 12 13.228c.364-.363.864-.59 1.41-.681a.408.408 0 0 0 .408-.41z",
    fill: "#FFE27A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.864 15.591c0-1.273 1-2.273 2.272-2.273.546 0 1.046.182 1.455.546-.455-.546-1.046-.864-1.773-.864a2.25 2.25 0 0 0-2.272 2.273c0 .727.318 1.318.818 1.727-.319-.364-.5-.864-.5-1.409z",
    fill: "#F19920"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.182 16.682c-.046 0-.091 0-.137-.046a.22.22 0 0 1 0-.318c.273-.273.41-.682.41-1.045 0-.137.09-.228.227-.228.136 0 .227.091.227.228 0 .5-.182 1-.5 1.363-.09.046-.182.046-.227.046z",
    fill: "#FFCB5B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.818 16.636c-.272 0-.454-.181-.454-.454v-1.819c0-.272.181-.454.454-.454s.455.181.455.454v1.819c0 .273-.182.454-.455.454z",
    fill: "#F19920"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.909 14.409c.09.273.181.545.181.864 0 1.272-1 2.272-2.272 2.272-.136 0-.319 0-.455-.045v.045c0 .319.046.591.136.91h.319A3.162 3.162 0 0 0 17 15.272c0-.319-.046-.591-.137-.91h-.318c-.227 0-.409 0-.636.046z",
    fill: "#F6B545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.09 21.182a3.182 3.182 0 1 0 .001-6.364 3.182 3.182 0 0 0 0 6.364z",
    fill: "#F6B545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.09 14.818A3.162 3.162 0 0 0 12.91 18a3.162 3.162 0 0 0 3.18 3.182A3.162 3.162 0 0 0 19.274 18a3.162 3.162 0 0 0-3.182-3.182zm0 5.455A2.25 2.25 0 0 1 13.819 18c0-1.273 1-2.273 2.273-2.273 1.273 0 2.273 1 2.273 2.273 0 1.273-1 2.273-2.273 2.273z",
    fill: "#FFCB5B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.091 21.136c1.773.046 3.182-1.409 3.182-3.136h-.046c-.227 0-.409.182-.454.409a2.748 2.748 0 0 1-.864 1.636c-.364.364-.864.591-1.409.682a.408.408 0 0 0-.409.41z",
    fill: "#F6B545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.09 14.864c-1.772-.046-3.18 1.409-3.18 3.136h.045c.227 0 .409-.182.454-.409a2.748 2.748 0 0 1 .864-1.636c.364-.364.864-.591 1.409-.682a.408.408 0 0 0 .409-.41z",
    fill: "#FFE27A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.136 18.318c0-1.272 1-2.272 2.273-2.272.545 0 1.045.181 1.455.545-.455-.545-1.046-.864-1.773-.864A2.25 2.25 0 0 0 13.818 18c0 .727.319 1.318.819 1.727-.319-.363-.5-.863-.5-1.409z",
    fill: "#F19920"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.455 19.409c-.046 0-.091 0-.137-.045a.22.22 0 0 1 0-.319c.273-.272.41-.681.41-1.045 0-.136.09-.227.227-.227.136 0 .227.09.227.227 0 .5-.182 1-.5 1.364-.091.045-.182.045-.227.045z",
    fill: "#FFCB5B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.091 19.364c-.273 0-.455-.182-.455-.455v-1.818c0-.273.182-.455.455-.455s.455.182.455.455v1.818c0 .273-.182.455-.455.455z",
    fill: "#F19920"
  }));
};
Cash.displayName = "Cash";
Cash.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var Cheque = function Cheque(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M20.828 7.977H3.172a.781.781 0 0 0-.781.78v9.727c0 .432.35.782.78.782h17.657c.432 0 .781-.35.781-.782V8.758a.781.781 0 0 0-.78-.781z",
    fill: "#C0E3F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.266 16.805v.616c0 .614-.182 1.331-.521 1.844l-.004.006-1.038 1.557-1.037-1.556-.004-.007c-.34-.513-.521-1.23-.521-1.844v-.616h3.125z",
    fill: "#FEB756"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.14 16.805h3.126V7.977H16.14v8.828zM18.484 4.852c.432 0 .782.35.782.78a.781.781 0 0 0-.782.782h-2.343v-.781c0-.432.35-.781.78-.781h1.563z",
    fill: "#4DBBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.818 5.862a.781.781 0 0 0-1.334.552h-2.343v1.563h2.343V10.555a.781.781 0 1 0 1.563 0V6.414a.779.779 0 0 0-.229-.552zM18.484 3.172v1.68h-1.562v-1.68a.781.781 0 1 1 1.562 0z",
    fill: "#FEB756"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.422 15.633a.39.39 0 1 0 0 .781.39.39 0 0 0 0-.781zM7.078 11.727c.215 0 .39.175.39.39a.39.39 0 0 0 .782 0c0-.646-.526-1.172-1.172-1.172h-.39v-.39a.39.39 0 0 0-.782 0v.39h-.39c-.646 0-1.172.526-1.172 1.172v.781c0 .646.526 1.172 1.172 1.172h.39v1.563h-.39a.391.391 0 0 1-.391-.39.39.39 0 0 0-.781 0c0 .645.526 1.171 1.172 1.171h.39v.39a.39.39 0 0 0 .782 0v-.39h.39c.646 0 1.172-.526 1.172-1.172v-.781c0-.646-.526-1.172-1.172-1.172h-.39v-1.562h.39zm0 2.343c.215 0 .39.176.39.39v.782c0 .215-.175.39-.39.39h-.39V14.07h.39zm-1.172-.78h-.39a.391.391 0 0 1-.391-.392v-.78c0-.216.175-.391.39-.391h.391v1.562z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.828 7.586h-.39V6.414c0-.313-.122-.607-.344-.828a1.164 1.164 0 0 0-.489-.294 1.177 1.177 0 0 0-.73-.764V3.172c0-.313-.122-.607-.343-.829a1.173 1.173 0 0 0-2 .829v1.356a1.174 1.174 0 0 0-.782 1.105v1.953H3.172C2.526 7.586 2 8.112 2 8.758v9.726c0 .646.526 1.172 1.172 1.172h13.28l.864 1.295-.003.656c-.001.216.172.392.388.393h.002a.39.39 0 0 0 .39-.389l.004-.669.856-1.286h1.875c.646 0 1.172-.525 1.172-1.172V8.758c0-.646-.526-1.172-1.172-1.172zm-3.125 12.538l-.71-1.065-.005-.01c-.277-.417-.457-1.057-.457-1.628v-.226h2.344v.226c0 .571-.179 1.21-.456 1.629-.002.003-.005.006-.006.01l-.71 1.064zm-1.172-13.32h1.563v.782H16.53v-.781zm3.01-.666a.388.388 0 0 1 .115.276v2.969h-.781V6.414a.391.391 0 0 1 .667-.276zm-.666 10.276h-2.344V8.367h1.563v2.188c0 .51.326.943.781 1.104v4.755zm.39-5.469a.391.391 0 0 1-.39-.39v-.39h.781v.39c0 .215-.175.39-.39.39zm-1.953-7.773a.391.391 0 0 1 .782 0V4.46h-.782V3.17zm-.39 2.07h1.562a.39.39 0 0 1 .276.115 1.178 1.178 0 0 0-.6.666h-1.629v-.39c0-.215.176-.39.39-.39zM2.782 18.484V8.758c0-.215.175-.39.39-.39H15.75v2.577H9.422a.39.39 0 0 0 0 .782h6.328v1.562H9.422a.39.39 0 0 0 0 .781h6.328v1.563h-4.766a.39.39 0 0 0 0 .781h4.766v1.007a4.1 4.1 0 0 0 .278 1.454H3.172a.391.391 0 0 1-.39-.39zm18.437 0c0 .216-.176.391-.39.391h-1.45c.176-.452.277-.967.277-1.454V11.66c.455-.161.782-.595.782-1.104V8.367h.39c.215 0 .39.176.39.39v9.727z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.703 11.727a.39.39 0 0 0-.39.39v3.125a.39.39 0 0 0 .78 0v-3.125a.39.39 0 0 0-.39-.39z",
    fill: "#000"
  }));
};
Cheque.displayName = "Cheque";
Cheque.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var Interac = function Interac(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22 20.333c0 .921-.747 1.667-1.667 1.667H3.667A1.666 1.666 0 0 1 2 20.333V3.667C2 2.746 2.746 2 3.667 2h16.666C21.253 2 22 2.745 22 3.667v16.666z",
    fill: "#EDAA00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.167 12.216l-.002-3.581.935-.221v.468s.242-.617.804-.76c.173-.044.26-.018.26-.018v.914s-.213-.009-.49.102c-.345.137-.52.434-.52.888l.002 1.977-.99.23zM8.239 13.38s-.151-.228-.151-1.034v-1.783l-.481.115v-.735l.481-.114v-.8l.995-.235v.8l.702-.166v.733l-.702.167s-.002 1.46 0 1.816c0 .825.219.983.219.983l-1.063.253zM9.889 11.25c0-.637.09-1.101.285-1.458.231-.423.611-.698 1.164-.824 1.09-.248 1.484.397 1.468 1.262-.005.31-.003.46-.003.46l-1.921.452v.03c0 .606.127.893.51.811.33-.07.423-.277.449-.533.004-.042.006-.147.006-.147l.9-.216s.002.074.001.156c-.008.344-.108 1.197-1.358 1.492-1.185.282-1.501-.442-1.501-1.485zm1.49-1.615c-.32.072-.486.384-.493.901l.966-.23c.002-.023.002-.075.002-.156-.001-.39-.122-.596-.476-.515zM18.528 9.156c-.037-1.091.245-1.957 1.461-2.232.777-.176 1.071.025 1.22.22.143.186.199.437.199.789v.065l-.952.226V8.09c0-.417-.115-.575-.418-.5-.36.091-.506.432-.506 1.112 0 .241.002.285.002.317 0 .69.094 1.007.509.92.36-.074.409-.39.415-.667l.003-.183.95-.225.001.149c-.002.905-.48 1.476-1.374 1.684-1.231.288-1.473-.424-1.51-1.542zM15.236 10.682c0-.829.487-1.092 1.219-1.394.657-.272.67-.407.674-.644.004-.198-.088-.369-.416-.285-.3.076-.38.294-.396.468-.01.094-.007.184-.007.184l-.922.218s-.015-.285.064-.546c.147-.496.585-.83 1.34-1.004.98-.226 1.308.204 1.31.874v1.586c0 .767.142.88.142.88l-.906.214s-.085-.176-.122-.326c0 0-.198.5-.881.66-.718.17-1.099-.274-1.099-.885zm1.887-1.132s-.189.139-.482.282c-.302.148-.439.33-.439.61 0 .242.15.402.424.334.293-.074.497-.347.497-.727v-.5zM3.043 15.89a.575.575 0 0 1-.481-.888l.006-.008.011-.002 1.352-.32V15.7l-.021.005c-.307.074-.673.158-.749.173a.492.492 0 0 1-.118.013zM3.043 17.203a.574.574 0 0 1-.481-.885l.006-.01.011-.002 1.352-.32v1.027l-.021.006c-.307.073-.673.158-.749.173a.581.581 0 0 1-.118.011zM3.043 18.52a.574.574 0 0 1-.481-.887l.006-.01 1.363-.321v1.026l-.021.006c-.324.078-.684.16-.749.174a.644.644 0 0 1-.118.012zM2.884 14.632V8.888L3.93 8.64v5.744l-1.046.248zM5.492 14.143a.647.647 0 0 0-1.292 0v5.37c0 .963.785 1.749 1.75 1.749l1.828-.003v-2.24l.001-2.497a.846.846 0 0 0-.376-.704l-1.63-1.108v2.515a.14.14 0 0 1-.14.14.14.14 0 0 1-.138-.14l-.003-3.082zM6.365 10.138c-.677.155-.933.72-.933.72v-.404l-.942.223v2.579a.963.963 0 0 1 .993.173v-1.665c0-.398.2-.717.482-.78.214-.046.392.03.392.41v2.429l.994-.233v-2.57c0-.622-.24-1.057-.986-.882zM20.796 6.461a.615.615 0 0 1 0-1.228.615.615 0 0 1 0 1.228zm0-1.15a.538.538 0 0 0 0 1.073.537.537 0 0 0 0-1.074z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.572 5.481h.265c.106 0 .19.053.19.193 0 .097-.043.172-.125.185v.001c.074.008.113.049.117.154.002.048.002.107.005.153.002.036.02.054.036.064h-.136c-.012-.014-.017-.036-.02-.066-.004-.045-.004-.087-.005-.142-.002-.081-.027-.117-.11-.117h-.097v.325h-.12v-.75zm.216.335c.077 0 .12-.047.12-.123 0-.08-.035-.12-.114-.12h-.102v.243h.096z",
    fill: "#000"
  }));
};
Interac.displayName = "Interac";
Interac.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var Mastercard = function Mastercard(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M8.168 18.337A6.168 6.168 0 1 0 8.168 6a6.168 6.168 0 0 0 0 12.337z",
    fill: "#EE0005"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.832 18.337a6.168 6.168 0 1 0 0-12.337 6.168 6.168 0 0 0 0 12.337z",
    fill: "#F9A000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.664 12.168c0 1.959.912 3.704 2.336 4.834a6.157 6.157 0 0 0 2.336-4.834A6.157 6.157 0 0 0 12 7.334a6.159 6.159 0 0 0-2.336 4.834z",
    fill: "#FF6300"
  }));
};
Mastercard.displayName = "Mastercard";
Mastercard.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var Visa = function Visa(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M7.483 9.127l-1.848 4.678-.75-3.978c-.085-.444-.433-.701-.82-.701H1.04l-.04.2c.62.137 1.326.352 1.754.584.26.142.337.267.42.605L4.595 16h1.879l2.88-6.873h-1.87zM10.116 9.127L8.646 16h1.777l1.467-6.873h-1.774zM14.224 11.032c.006-.247.24-.508.755-.578.256-.032.956-.057 1.754.308l.311-1.456A4.779 4.779 0 0 0 15.381 9c-1.757 0-2.993.936-3.005 2.274-.01.989.884 1.54 1.556 1.87.693.335.927.551.922.855-.003.461-.552.663-1.061.671-.896.014-1.414-.24-1.829-.433l-.32 1.505c.415.191 1.182.357 1.978.365 1.866 0 3.087-.923 3.093-2.351.008-1.815-2.508-1.914-2.49-2.724zM19.373 13.566l.945-2.58.532 2.58h-1.477zm.673-4.439a.81.81 0 0 0-.757.505L16.622 16h1.869l.37-1.026h2.276L21.352 16H23l-1.434-6.873h-1.52z",
    fill: "#292D6C"
  }));
};
Visa.displayName = "Visa";
Visa.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var Money = function Money(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M12.3 10.9c-2.27-.59-3-1.2-3-2.15 0-1.09 1.01-1.85 2.7-1.85 1.42 0 2.13.54 2.39 1.4.12.4.45.7.87.7h.3c.66 0 1.13-.65.9-1.27-.42-1.18-1.4-2.16-2.96-2.54V4.5c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v.66C8.56 5.58 7 6.84 7 8.77c0 2.31 1.91 3.46 4.7 4.13 2.5.6 3 1.48 3 2.41 0 .69-.49 1.79-2.7 1.79-1.65 0-2.5-.59-2.83-1.43-.15-.39-.49-.67-.9-.67h-.28c-.67 0-1.14.68-.89 1.3.57 1.39 1.9 2.21 3.4 2.53v.67c0 .83.67 1.5 1.5 1.5s1.5-.67 1.5-1.5v-.65c1.95-.37 3.5-1.5 3.5-3.55 0-2.84-2.43-3.81-4.7-4.4z",
    fill: "#9da3a8"
  }));
};
Money.displayName = "Money";
Money.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var TexadaWeb = function TexadaWeb(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M4 13c.55 0 1-.45 1-1s-.45-1-1-1-1 .45-1 1 .45 1 1 1zM4 17c.55 0 1-.45 1-1s-.45-1-1-1-1 .45-1 1 .45 1 1 1zM4 9c.55 0 1-.45 1-1s-.45-1-1-1-1 .45-1 1 .45 1 1 1zM8 13h12c.55 0 1-.45 1-1s-.45-1-1-1H8c-.55 0-1 .45-1 1s.45 1 1 1zM8 17h12c.55 0 1-.45 1-1s-.45-1-1-1H8c-.55 0-1 .45-1 1s.45 1 1 1zM7 8c0 .55.45 1 1 1h12c.55 0 1-.45 1-1s-.45-1-1-1H8c-.55 0-1 .45-1 1z",
    fill: "#B8CBD9"
  }));
};
TexadaWeb.displayName = "TexadaWeb";
TexadaWeb.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var Receipt = function Receipt(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.989 2.21h.01-.01zm0 0a.468.468 0 0 0-.34.15l-.79.79c-.2.2-.51.2-.71 0l-.79-.79c-.2-.2-.51-.2-.71 0l-.79.79c-.2.2-.51.2-.71 0l-.79-.79c-.2-.2-.51-.2-.71 0l-.79.79c-.2.2-.51.2-.71 0l-.79-.79c-.2-.2-.51-.2-.71 0l-.79.79c-.2.2-.51.2-.71 0l-.8-.8c-.2-.2-.51-.2-.71 0l-.79.8c-.2.2-.51.2-.71 0l-.79-.8c-.2-.2-.51-.2-.71 0l-.79.8c-.2.2-.51.2-.71 0l-.789-.8A.5.5 0 0 0 3 2.21V21.8c.13 0 .26-.05.35-.15l.79-.79c.2-.2.51-.2.71 0l.79.79c.2.2.51.2.71 0l.79-.79c.2-.2.51-.2.71 0l.79.79c.2.2.51.2.71 0l.79-.79c.2-.2.51-.2.71 0l.79.79c.2.2.51.2.71 0l.79-.79c.2-.2.51-.2.71 0l.79.79c.2.2.51.2.71 0l.79-.79c.2-.2.51-.2.71 0l.79.79c.2.2.51.2.71 0l.789-.79c.2-.2.51-.2.71 0l.79.79c.1.1.23.15.35.15V2.21zM6.999 17h10c.55 0 1-.45 1-1s-.45-1-1-1h-10c-.55 0-1 .45-1 1s.45 1 1 1zm10-4h-10c-.55 0-1-.45-1-1s.45-1 1-1h10c.55 0 1 .45 1 1s-.45 1-1 1zm-10-4h10c.55 0 1-.45 1-1s-.45-1-1-1h-10c-.55 0-1 .45-1 1s.45 1 1 1z",
    fill: "#9da3a8"
  }));
};
Receipt.displayName = "Receipt";
Receipt.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var Restore = function Restore(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.144 12.002c0-5.06 4.17-9.14 9.26-9 4.69.13 8.61 4.05 8.74 8.74.14 5.09-3.95 9.26-9 9.26-2.08 0-4-.71-5.52-1.9-.47-.37-.5-1.07-.08-1.5.36-.36.92-.39 1.32-.08 1.18.93 2.67 1.48 4.28 1.48 3.9 0 7.05-3.19 7-7.1-.05-3.72-3.18-6.85-6.9-6.9-3.92-.05-7.1 3.1-7.1 7h1.8c.44 0 .67.54.35.85l-2.79 2.8c-.2.2-.51.2-.71 0l-2.79-2.8c-.32-.31-.1-.85.35-.85h1.79zm8-3.25c0-.41.34-.75.75-.75.42 0 .75.34.75.74v3.4l2.88 1.71c.35.21.47.67.26 1.03-.21.35-.67.47-1.03.26l-3.12-1.85c-.3-.18-.49-.51-.49-.86v-3.68z",
    fill: "#9DA3A8"
  }));
};
Restore.displayName = "Restore";
Restore.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var Store = function Store(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 6.995h13.999c.55 0 1-.45 1-1s-.45-1-1-1h-14c-.55 0-1 .45-1 1s.45 1 1 1zm15.159 1.8c-.09-.46-.5-.8-.98-.8H4.819c-.48 0-.89.34-.98.8l-1 5c-.12.62.35 1.2.98 1.2H4v5c0 .55.45 1 1 1h8c.55 0 1-.45 1-1v-5h4v5c0 .55.45 1 1 1s1-.45 1-1v-5h.18c.63 0 1.1-.58.98-1.2l-1-5zm-14.16 10.2h6v-4H6v4z",
    fill: "#9da3a8"
  }));
};
Store.displayName = "Store";
Store.defaultProps = {
  width: "24",
  height: "25",
  viewBox: "0 0 24 25",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var AccountBalance = function AccountBalance(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.17 7.016l7.9-4.16c.58-.31 1.28-.31 1.86 0l7.899 4.16c.41.21.67.64.67 1.1 0 .69-.56 1.25-1.24 1.25H3.749c-.69 0-1.25-.56-1.25-1.25 0-.46.26-.89.67-1.1zm1.33 5.85v4c0 .83.67 1.5 1.5 1.5s1.5-.67 1.5-1.5v-4c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5zm6 0v4c0 .83.67 1.5 1.5 1.5s1.5-.67 1.5-1.5v-4c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5zm10.999 9c0 .83-.67 1.5-1.5 1.5h-16c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5h16c.83 0 1.5.67 1.5 1.5zm-5-9v4c0 .83.67 1.5 1.5 1.5s1.5-.67 1.5-1.5v-4c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5z",
    fill: "#9da3a8"
  }));
};
AccountBalance.displayName = "AccountBalance";
AccountBalance.defaultProps = {
  width: "24",
  height: "25",
  viewBox: "0 0 24 25",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var FileCopy = function FileCopy(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.5 1h-11c-1.1 0-2 .9-2 2v13c0 .55.45 1 1 1s1-.45 1-1V4c0-.55.45-1 1-1h10c.55 0 1-.45 1-1s-.45-1-1-1zm.589 4.59l4.83 4.83c.37.37.58.88.58 1.41V21c0 1.1-.9 2-2 2H8.489c-1.1 0-1.99-.9-1.99-2l.01-14c0-1.1.89-2 1.99-2h6.17c.53 0 1.04.21 1.42.59zm3.91 6.41h-4.5c-.55 0-1-.45-1-1V6.5L20 12z",
    fill: "#9da3a8"
  }));
};
FileCopy.displayName = "FileCopy";
FileCopy.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var Camera = function Camera(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 5h-3.17l-1.24-1.35A1.99 1.99 0 0 0 14.12 3H9.88c-.56 0-1.1.24-1.48.65L7.17 5H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm-8 5a3 3 0 1 0 0 6 3 3 0 0 0 0-6zm-5 3c0 2.76 2.24 5 5 5s5-2.24 5-5-2.24-5-5-5-5 2.24-5 5z",
    fill: "#696F74"
  }));
};
Camera.displayName = "Camera";
Camera.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var TrendingFlat = function TrendingFlat(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M21.254 11.65l-2.79-2.79a.501.501 0 0 0-.86.35V11h-14c-.55 0-1 .45-1 1s.45 1 1 1h14v1.79c0 .45.54.67.85.35l2.79-2.79c.2-.19.2-.51.01-.7z",
    fill: "#000"
  }));
};
TrendingFlat.displayName = "TrendingFlat";
TrendingFlat.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var Archive = function Archive(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.54 5.23l-1.39-1.68C18.88 3.21 18.47 3 18 3H6c-.47 0-.88.21-1.16.55L3.46 5.23C3.17 5.57 3 6.02 3 6.5V19c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V6.5c0-.48-.17-.93-.46-1.27zm-8.89 11.92L6.5 12H10v-2h4v2h3.5l-5.15 5.15c-.19.19-.51.19-.7 0zM5.93 4l-.81 1h13.75l-.94-1h-12z",
    fill: "#494F54"
  }));
};
Archive.displayName = "Archive";
Archive.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var Sparkle = function Sparkle(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "a",
    patternContentUnits: "objectBoundingBox",
    width: "1",
    height: "1"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b",
    transform: "scale(.00625)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "b",
    width: "160",
    height: "160",
    preserveAspectRatio: "none",
    xlinkHref: "data:image/png;base64,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"
  })));
};
Sparkle.displayName = "Sparkle";
Sparkle.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink"
};
export { AddBox, Business, CalendarTodayBlack, DragIndicator, EventAvailable, Event, Lock, VerifiedUser, Assignment, NewReleases, PlayArrow, Stop, Feedback, PresentToAll, HowToReg, FilterList, Contract, CreditCards, Destination, Driver, Ellipse, Exit, Filter, Group, Invoices, Loading, Open, OpenFile, Operator, Origin, Return, Services, Signature, Tickets, Tools, Unloading, CashAccount, Export, Inquiry, Inventory, Next, Previous, DeliveryTicket, PickupTicket, TaskTicket, HeadsetMic, Keyboard, Gateway, ColorLens, Image, Priority, AccountBox, AccountCircle, AddShoppingCart, Build, Cached, Calendar, Cart, Check, CheckCircle, CreditCard, Dashboard, Delete, DeleteForever, Description, Download, Face, HelpOutline, Home, Info, Label, Payment, Print, QuestionAnswer, SandGlass, SandGlassCircle, Schedule, Search, Settings, SwapHoriz, Visibility, VisibilityOff, WatchLater, Work, WorkOff, WorkOutline, Warning, FiberManualRecord, Pause, PauseCircle, SkipNext, SkipPrevious, Comment, Phone, Add, AddCircle, Block, Close, Drafts, Clone, Create, Edit, Email, Flag, InsertLink, OutlinedFlag, Remove, RemoveCircleOutline, Save, Task, Undo, AccessTime, Dvr, Attachment, Upload, Place, Shipping, CreatedMarker, AssignedMarker, InprogressMarker, PausedMarker, CompletedMarker, ArrowBack, ArrowDropDown, ArrowDropUp, ArrowForward, ArrowLeft, Cancel, ExpandMore, KeyboardArrowLeft, KeyboardArrowRight, CheckBox, CheckBoxOutlineBlank, IndeterminateCheckBox, RadioButtonChecked, RadioButtonUnchecked, Star, StarBorder, ArrowBackIos, ArrowDownward, ArrowForwardIos, ArrowUpward, ExpandLess, Fullscreen, Menu, MoreHoriz, MoreVert, Amex, Cash, Cheque, Interac, Mastercard, Visa, Money, WorkOrder, AdminPanelSettings, HistoryToggleOff, Widgets, SwapHorizontalCircle, LinkOff, History, TexadaWeb, Receipt, Restore, Store, AccountBalance, FileCopy, Camera, TrendingFlat, Archive, Sparkle };
//# sourceMappingURL=index.js.map